var _path, _polygon, _polygon2, _path2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    width: 33.122,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    width: 8.693,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    width: 19.192,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.889,
    width: 43.193,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.889,
    width: 6.333,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    width: 93.676,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708H237.014c3.147,0,5.707,2.561,5.707,5.708V332.092c0,3.147-2.56,5.708-5.707,5.708ZM43.915,55.203c-3.01,0-5.458,2.448-5.458,5.458V332.092c0,3.01,2.448,5.458,5.458,5.458H237.014c3.009,0,5.457-2.448,5.457-5.458V60.66c0-3.009-2.448-5.458-5.457-5.458H43.915Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8h-193.099c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.56-5.708,5.707-5.708h193.099c3.148,0,5.708,2.561,5.708,5.708V332.092c0,3.147-2.561,5.708-5.708,5.708ZM260.212,55.203c-3.009,0-5.457,2.448-5.457,5.458V332.092c0,3.01,2.448,5.458,5.457,5.458h193.099c3.01,0,5.458-2.448,5.458-5.458V60.66c0-3.009-2.448-5.458-5.458-5.458h-193.099Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.723,157.588c-1.576-7.602-4.588-14.67-8.708-20.947l7.501-9.059-16.035-16.036-9.06,7.5c-6.277-4.118-13.345-7.132-20.946-8.707l-1.1-11.677h-22.678l-1.1,11.677c-7.601,1.576-14.67,4.589-20.946,8.707l-9.06-7.5-16.036,16.036,7.5,9.06c-4.119,6.276-7.131,13.344-8.708,20.946l-11.677,1.101v22.676l11.677,1.101c1.577,7.601,4.589,14.668,8.708,20.945l-7.5,9.06,16.036,16.036,9.06-7.502c6.276,4.121,13.345,7.133,20.946,8.709l1.1,11.677h22.678l1.1-11.676c7.601-1.575,14.669-4.589,20.946-8.71l9.06,7.502,16.035-16.036-7.501-9.059c4.12-6.278,7.132-13.345,8.708-20.946l11.677-1.101v-22.676l-11.677-1.101Zm-28.989,12.439c0,16.954-13.745,30.7-30.7,30.7s-30.7-13.745-30.7-30.7,13.745-30.7,30.7-30.7,30.7,13.745,30.7,30.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.765,266.424l.79,8.391h16.294l.789-8.389c5.463-1.133,10.541-3.298,15.051-6.258l6.51,5.39,11.522-11.523-5.389-6.509c2.961-4.51,5.124-9.589,6.258-15.05l8.388-.79v-16.293l-8.388-.791c-1.133-5.463-3.297-10.541-6.258-15.049l5.389-6.51-11.522-11.523-6.51,5.389c-4.51-2.958-9.588-5.124-15.051-6.257l-.789-8.387-16.294-.002-.79,8.39c-5.462,1.134-10.54,3.299-15.051,6.257l-6.509-5.389-11.522,11.523,5.389,6.51c-2.96,4.51-5.124,9.587-6.257,15.049l-8.39,.791v16.293l8.39,.79c1.132,5.46,3.297,10.54,6.256,15.05l-5.389,6.509,11.522,11.523,6.509-5.39c4.511,2.96,9.589,5.124,15.051,6.256Zm8.936-20.828c-12.181,0-22.057-9.876-22.057-22.058s9.876-22.057,22.057-22.057,22.058,9.875,22.058,22.057-9.875,22.058-22.058,22.058Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.24,380.524h19.4l.94-9.988c6.503-1.348,12.548-3.927,17.917-7.45l7.75,6.416,13.717-13.717-6.415-7.75c3.523-5.369,6.1-11.415,7.448-17.919l9.988-.94v-19.399l-9.988-.941c-1.349-6.503-3.926-12.549-7.448-17.918l6.415-7.751-13.717-13.716-7.75,6.415c-5.37-3.523-11.415-6.101-17.917-7.45l-.94-9.988h-19.4l-.94,9.988c-6.503,1.349-12.548,3.927-17.919,7.45l-7.749-6.415-13.718,13.716,6.417,7.751c-3.524,5.37-6.102,11.415-7.45,17.918l-9.989,.941v19.399l9.989,.94c1.348,6.504,3.926,12.55,7.45,17.917l-6.417,7.752,13.718,13.717,7.749-6.416c5.371,3.523,11.416,6.101,17.919,7.45l.94,9.988Zm9.7-34.787c-14.504,0-26.261-11.757-26.261-26.261s11.757-26.261,26.261-26.261,26.261,11.758,26.261,26.261-11.758,26.261-26.261,26.261Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.761,121.173h13.537c4.087,0,7.401,3.313,7.401,7.401v8.932c0,4.087-3.314,7.401-7.401,7.401h-1.23l.713,5.418-5.691-5.418h-7.33c-4.087,0-7.4-3.314-7.4-7.401v-8.932c0-4.088,3.313-7.401,7.401-7.401Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.809,331.372h13.537c4.087,0,7.401,3.313,7.401,7.401v8.932c0,4.087-3.314,7.401-7.401,7.401h-1.23l.713,5.418-5.691-5.418h-7.33c-4.087,0-7.4-3.314-7.4-7.401v-8.932c0-4.087,3.313-7.401,7.401-7.401Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.049,312.987h-13.537c-4.087,0-7.401,3.313-7.401,7.401v8.932c0,4.087,3.314,7.401,7.401,7.401h1.23l-.713,5.418,5.691-5.418h7.33c4.087,0,7.4-3.314,7.4-7.401v-8.932c0-4.087-3.313-7.401-7.401-7.401Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.531,292.523h-13.537c-4.087,0-7.401,3.313-7.401,7.401v8.932c0,4.087,3.314,7.401,7.401,7.401h1.23l-.713,5.418,5.691-5.418h7.33c4.087,0,7.4-3.314,7.4-7.401v-8.932c0-4.087-3.313-7.401-7.401-7.401Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.67,249.52c-.304,1.566-2.699,2.419-5.35,1.905s-4.554-2.201-4.25-3.768c.304-1.566,2.699-2.419,5.35-1.905,2.651,.514,4.554,2.201,4.25,3.768Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.753,244.723c.331-.239,.549-.523,.613-.852,.298-1.538-2.73-3.419-6.765-4.202-4.034-.783-7.547-.171-7.845,1.367-.064,.329,.032,.673,.25,1.019-.109,.144-.186,.299-.219,.467-.063,.325,.037,.666,.26,1.009-.117,.146-.196,.305-.229,.477-.063,.323,.042,.663,.274,1.003-.124,.147-.209,.308-.243,.483-.062,.322,.046,.661,.289,.999-.132,.147-.223,.309-.258,.487-.248,1.279,2.27,2.843,5.624,3.494,3.354,.651,6.274,.142,6.522-1.137,.034-.178,.01-.362-.057-.548,.352-.224,.58-.497,.642-.819,.034-.176,.016-.356-.045-.539,.343-.229,.567-.505,.629-.828,.034-.172,.02-.349-.034-.529,.335-.234,.556-.513,.619-.838,.033-.168,.019-.34-.028-.515Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.455,232.247c1.444-7.443-3.686-14.637-11.342-15.582-6.605-.815-12.868,3.556-14.398,10.032-.994,4.21,.143,8.383,2.677,11.443,.46,.555,.633,1.297,.428,1.988-.01,.034-.018,.068-.025,.103-.303,1.562,2.773,3.473,6.869,4.268,4.097,.795,7.664,.173,7.967-1.389,.006-.034,.011-.067,.015-.101,.071-.726,.519-1.35,1.159-1.698,3.338-1.812,5.87-5.044,6.65-9.064Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.352,242.176c-.254-.051-.419-.297-.369-.552,.865-4.458-2.052-8.581-2.081-8.623-.113-.157-.119-.367-.014-.53,.104-.162,.297-.245,.487-.208l2.127,.412,.959-1.42c.101-.15,.279-.228,.458-.203,.191,.031,.328,.153,.382,.325l.771,2.441,1.628-1.976c.113-.136,.312-.183,.465-.16,.173,.038,.31,.17,.355,.341l.707,2.713,1.67-2.252c.111-.148,.318-.222,.478-.18,.181,.04,.322,.181,.361,.362l.358,1.676,2.128,.413h.003c.207,.042,.362,.217,.377,.428,.015,.212-.113,.409-.314,.479-3.385,1.185-5.466,7.098-5.486,7.157-.085,.246-.35,.375-.599,.291-.246-.085-.377-.353-.292-.599,.08-.231,1.773-5.048,4.796-7.091l-1.098-.213c-.215-.055-.332-.179-.371-.364l-.206-.961-1.635,2.205c-.108,.146-.29,.217-.468,.182-.182-.049-.32-.168-.366-.344l-.722-2.773-1.593,1.933c-.11,.133-.284,.196-.454,.163-.178,.024-.307-.155-.359-.321l-.739-2.338-.587,.869c-.106,.156-.294,.234-.48,.199l-1.372-.266c.878,1.555,2.347,4.83,1.652,8.409-.05,.255-.297,.422-.552,.373h-.003Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.443,381.368c.651,1.207-.477,3.078-2.519,4.18s-4.226,1.017-4.877-.19c-.651-1.207,.477-3.078,2.519-4.18s4.226-1.017,4.877,.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.879,376.501c.09-.34,.08-.647-.056-.9-.639-1.185-3.677-.786-6.785,.891s-5.109,3.996-4.47,5.181c.137,.253,.388,.43,.721,.541,.006,.155,.039,.3,.109,.43,.135,.251,.387,.423,.722,.529,.002,.161,.036,.31,.108,.442,.134,.249,.389,.418,.728,.518-.003,.165,.029,.318,.102,.453,.134,.248,.39,.414,.736,.507-.008,.17,.02,.327,.094,.464,.531,.985,3.057,.654,5.641-.74,2.584-1.394,4.248-3.323,3.716-4.308-.074-.137-.19-.246-.336-.333,.112-.34,.114-.646-.019-.894-.073-.135-.183-.245-.323-.334,.103-.339,.102-.644-.033-.893-.071-.133-.177-.243-.31-.333,.096-.338,.09-.644-.045-.894-.07-.129-.173-.237-.299-.327Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.869,363.468c-3.093-5.734-10.422-7.722-16.025-4.181-4.834,3.055-6.617,9.371-4.107,14.51,1.631,3.34,4.66,5.495,8.011,6.148,.608,.119,1.127,.517,1.367,1.089,.012,.028,.025,.055,.039,.082,.649,1.203,3.734,.798,6.89-.904,3.156-1.703,5.189-4.058,4.54-5.262-.014-.026-.029-.051-.045-.075-.348-.521-.39-1.18-.154-1.76,1.232-3.022,1.155-6.55-.516-9.647Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.243,379.927c-.197,.104-.44,.031-.546-.166-1.853-3.435-6.037-4.587-6.079-4.598-.16-.043-.279-.179-.298-.344-.019-.165,.064-.324,.21-.404l1.638-.884-.136-1.466c-.014-.154,.061-.304,.194-.384,.144-.083,.301-.077,.431,.008l1.842,1.203,.006-2.2c0-.152,.108-.292,.222-.36,.136-.069,.299-.056,.422,.034l1.948,1.419-.116-2.406c-.007-.159,.091-.321,.22-.38,.142-.072,.312-.055,.437,.044l1.15,.919,1.639-.884h.003c.16-.086,.358-.054,.483,.078,.126,.133,.148,.333,.052,.489-1.604,2.631,.232,7.695,.252,7.745,.077,.21-.029,.44-.24,.52-.21,.078-.443-.03-.52-.239-.072-.197-1.57-4.321-.674-7.326l-.846,.457c-.173,.081-.318,.062-.445-.04l-.66-.526,.114,2.356c.007,.156-.075,.302-.212,.376-.148,.067-.305,.063-.431-.029l-1.99-1.45-.006,2.152c0,.148-.082,.285-.213,.355-.105,.113-.289,.064-.414-.017l-1.764-1.152,.083,.897c.015,.162-.068,.316-.211,.394l-1.056,.57c1.43,.555,4.191,1.933,5.678,4.69,.106,.197,.033,.442-.164,.549h-.003Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.431,138.348c.816,1.513-.598,3.86-3.159,5.242-2.561,1.382-5.299,1.275-6.116-.239-.816-1.513,.598-3.86,3.159-5.242,2.561-1.382,5.299-1.275,6.116,.239Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.725,132.244c.112-.426,.101-.811-.071-1.129-.802-1.486-4.611-.986-8.509,1.117-3.898,2.103-6.407,5.012-5.606,6.498,.171,.318,.487,.539,.904,.679,.008,.195,.049,.376,.137,.539,.169,.314,.486,.53,.906,.663,.002,.202,.045,.388,.135,.555,.168,.312,.488,.524,.913,.649-.003,.207,.036,.399,.128,.569,.168,.311,.489,.52,.923,.636-.01,.213,.025,.41,.117,.582,.666,1.235,3.834,.82,7.074-.928,3.24-1.748,5.327-4.167,4.661-5.402-.093-.172-.239-.309-.422-.417,.141-.427,.144-.81-.024-1.121-.092-.169-.23-.308-.405-.419,.13-.425,.127-.808-.041-1.12-.09-.166-.222-.305-.389-.417,.12-.424,.113-.807-.057-1.121-.087-.162-.217-.297-.375-.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.458,115.901c-3.879-7.191-13.069-9.684-20.096-5.243-6.062,3.831-8.298,11.752-5.15,18.196,2.046,4.188,5.844,6.891,10.046,7.71,.762,.149,1.414,.649,1.714,1.365,.015,.035,.031,.069,.049,.103,.814,1.509,4.683,1.001,8.641-1.134,3.958-2.135,6.507-5.089,5.693-6.599-.018-.032-.037-.064-.057-.094-.437-.653-.489-1.479-.193-2.207,1.545-3.79,1.448-8.214-.647-12.097Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.149,136.541c-.246,.131-.552,.038-.685-.208-2.323-4.307-7.571-5.752-7.624-5.766-.201-.054-.349-.225-.374-.432-.024-.206,.08-.407,.263-.506l2.055-1.109-.17-1.838c-.018-.194,.077-.381,.243-.482,.18-.104,.377-.097,.54,.01l2.31,1.508,.007-2.759c.001-.191,.136-.366,.278-.451,.17-.086,.374-.07,.529,.042l2.442,1.779-.146-3.017c-.009-.199,.114-.402,.276-.477,.178-.091,.392-.069,.548,.055l1.443,1.152,2.055-1.109,.003-.002c.201-.107,.449-.066,.606,.099,.158,.167,.185,.418,.065,.614-2.012,3.299,.292,9.65,.315,9.713,.097,.263-.036,.552-.301,.652-.263,.097-.555-.037-.652-.3-.091-.247-1.969-5.419-.845-9.186l-1.061,.573c-.217,.101-.399,.077-.558-.05l-.827-.66,.143,2.955c.009,.196-.094,.379-.266,.472-.185,.084-.382,.079-.54-.036l-2.495-1.819-.008,2.699c0,.186-.103,.357-.267,.445-.132,.142-.363,.081-.519-.022l-2.212-1.444,.104,1.125c.018,.203-.085,.397-.265,.494l-1.325,.715c1.794,.696,5.255,2.424,7.12,5.881,.133,.247,.041,.555-.206,.688l-.003,.002Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.484,273.738c0,3.684-3.582,6.547-7.445,5.289-.764-.249-1.473-.673-2.043-1.238-1.501-1.487-1.964-3.548-1.542-5.341h-6.869v8.32c0,.357-.191,.688-.502,.867-.31,.179-.691,.179-1.001-.003-.91-.529-2.065-.633-3.132-.224-1.183,.454-2.033,1.569-2.209,2.823-.309,2.209,1.405,4.107,3.554,4.107,.635,0,1.253-.164,1.787-.475,.31-.181,.691-.182,1.001-.003,.31,.179,.502,.51,.502,.867v8.359h19.232c2.992,0,5.417-2.425,5.417-5.417v-19.223h-6.897c.099,.419,.149,.852,.149,1.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.294,290.339c-3.608,0-6.428-3.436-5.362-7.208,.328-1.158,1.048-2.197,2.029-2.895,1.43-1.018,3.115-1.282,4.623-.928v-6.859h-8.33c-.36,0-.692-.193-.87-.506-.178-.314-.173-.697,.011-1.007,.449-.75,.594-1.693,.385-2.63-.291-1.304-1.358-2.357-2.661-2.653-2.341-.532-4.426,1.243-4.426,3.495,0,.645,.166,1.263,.479,1.787,.184,.31,.188,.693,.011,1.007-.178,.312-.51,.506-.87,.506h-8.37v19.223c0,2.992,2.425,5.417,5.417,5.417h19.223v-6.898c-.419,.099-.853,.149-1.29,.149Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.473,269.454c0-2.975,2.337-5.415,5.272-5.581,2.741-.155,5.293,1.805,5.806,4.502,.153,.805,.131,1.617-.049,2.378h6.861v-8.34c0-.36,.193-.692,.506-.87,.312-.178,.697-.174,1.006,.011,.748,.447,1.685,.593,2.62,.388,1.305-.287,2.36-1.35,2.66-2.651,.54-2.345-1.236-4.438-3.492-4.438-.645,0-1.263,.165-1.788,.479-.309,.184-.693,.188-1.006,.011-.313-.178-.506-.51-.506-.87v-8.369h-19.223c-2.992,0-5.417,2.425-5.417,5.417v19.232h6.901c-.1-.421-.151-.858-.151-1.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.885,252.549c3.563,0,6.359,3.352,5.399,7.069-.426,1.651-1.632,3.053-3.215,3.687-1.157,.463-2.375,.536-3.484,.274v6.871h8.33c.358,0,.689,.191,.867,.502,.178,.31,.177,.692-.003,1.001-.542,.932-.638,2.12-.192,3.221,.383,.944,1.204,1.683,2.178,1.983,2.458,.757,4.72-1.07,4.72-3.416,0-.637-.164-1.254-.474-1.787-.18-.309-.181-.691-.003-1.001,.179-.31,.509-.502,.867-.502h8.358v-19.232c0-2.992-2.425-5.417-5.417-5.417h-19.232v6.9c.421-.1,.857-.151,1.3-.151Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.227,365.7c3.27,1.414,4.506,5.601,2.149,8.631-1.047,1.346-2.71,2.155-4.415,2.108-1.245-.034-2.392-.451-3.307-1.132l-2.727,6.306,7.646,3.307c.328,.142,.556,.449,.597,.805,.041,.355-.112,.706-.4,.917-.867,.64-1.427,1.693-1.454,2.88-.024,1.019,.437,2.023,1.211,2.684,1.955,1.671,4.757,.891,5.688-1.262,.253-.584,.347-1.216,.274-1.828-.043-.355,.108-.707,.395-.92,.287-.214,.667-.259,.995-.116l7.672,3.318,7.634-17.652c1.188-2.746-.076-5.935-2.822-7.122l-17.651-7.634-2.739,6.333c.426,.076,.847,.202,1.253,.378Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.613,103.755c-1.316-3.311,.766-7.147,4.574-7.628,1.692-.214,3.44,.389,4.614,1.626,.857,.904,1.375,2.009,1.541,3.137l6.385-2.538-3.077-7.741c-.132-.333-.077-.711,.146-.991,.222-.28,.578-.42,.931-.367,1.066,.159,2.206-.19,3.064-1.012,.736-.704,1.119-1.74,1.038-2.756-.204-2.564-2.738-3.99-4.918-3.124-.592,.235-1.105,.616-1.486,1.101-.22,.281-.576,.424-.929,.372-.355-.051-.655-.288-.787-.62l-3.088-7.767-17.872,7.104c-2.78,1.105-4.138,4.255-3.033,7.035l7.104,17.871,6.412-2.549c-.248-.354-.457-.741-.621-1.153Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.416,94.02c3.27,1.414,4.506,5.601,2.15,8.631-1.047,1.346-2.71,2.155-4.415,2.108-1.245-.034-2.392-.451-3.307-1.132l-2.727,6.306,7.646,3.307c.329,.142,.556,.449,.597,.805,.041,.355-.112,.706-.4,.917-.867,.64-1.427,1.693-1.454,2.88-.024,1.019,.437,2.022,1.212,2.684,1.955,1.671,4.757,.891,5.688-1.262,.253-.584,.347-1.216,.274-1.828-.043-.355,.108-.707,.395-.92,.287-.214,.667-.259,.995-.117l7.672,3.318,7.634-17.652c1.188-2.746-.076-5.935-2.822-7.122l-17.651-7.634-2.739,6.333c.426,.076,.847,.202,1.253,.378Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,222.771l.257,2.729h5.3l.257-2.729c1.777-.369,3.429-1.073,4.896-2.035l2.117,1.753,3.748-3.748-1.753-2.117c.963-1.467,1.667-3.119,2.035-4.895l2.728-.257v-5.3l-2.728-.257c-.368-1.777-1.072-3.429-2.035-4.895l1.753-2.117-3.748-3.748-2.117,1.753c-1.467-.962-3.119-1.667-4.896-2.035l-.257-2.728h-5.3l-.257,2.728c-1.777,.369-3.428,1.073-4.896,2.035l-2.117-1.753-3.748,3.748,1.753,2.117c-.963,1.467-1.667,3.118-2.035,4.895l-2.729,.257v5.3l2.729,.257c.368,1.776,1.072,3.428,2.035,4.895l-1.753,2.117,3.748,3.748,2.117-1.753c1.467,.963,3.119,1.667,4.896,2.035Zm2.907-6.775c-3.962,0-7.175-3.212-7.175-7.175s3.212-7.174,7.175-7.174,7.175,3.212,7.175,7.174-3.212,7.175-7.175,7.175Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.695,159.7l.353,3.75h7.283l.353-3.75c2.442-.507,4.712-1.474,6.728-2.797l2.91,2.409,5.15-5.15-2.409-2.909c1.323-2.016,2.29-4.286,2.797-6.727l3.749-.353v-7.283l-3.749-.353c-.506-2.442-1.474-4.712-2.797-6.727l2.409-2.91-5.15-5.15-2.91,2.409c-2.016-1.322-4.286-2.291-6.728-2.797l-.353-3.749h-7.283l-.353,3.749c-2.441,.507-4.711,1.475-6.728,2.797l-2.909-2.409-5.15,5.15,2.409,2.91c-1.323,2.016-2.29,4.285-2.797,6.727l-3.75,.353v7.283l3.75,.353c.506,2.441,1.474,4.711,2.797,6.727l-2.409,2.909,5.15,5.15,2.909-2.409c2.016,1.323,4.286,2.291,6.728,2.797Zm3.994-9.31c-5.445,0-9.859-4.414-9.859-9.859s4.414-9.859,9.859-9.859,9.859,4.414,9.859,9.859-4.414,9.859-9.859,9.859Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-75"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--_Path_--inject-75",
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Team_work--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M324.075,381.089h-2.878v-1.043h6.944v1.043h-2.878v7.352h-1.188v-7.352Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.544,387.397v1.044h-6.093v-8.395h5.925v1.043h-4.726v2.579h4.21v1.02h-4.21v2.71h4.894Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.841,386.343h-4.461l-.924,2.099h-1.235l3.802-8.395h1.187l3.814,8.395h-1.259l-.923-2.099Zm-.42-.96l-1.811-4.113-1.811,4.113h3.622Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.059,388.441l-.012-6.117-3.035,5.098h-.552l-3.034-5.061v6.081h-1.151v-8.395h.983l3.502,5.9,3.454-5.9h.984l.012,8.395h-1.151Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.825,380.046l-2.806,8.395h-1.259l-2.291-6.704-2.291,6.704h-1.283l-2.807-8.395h1.235l2.267,6.824,2.363-6.824h1.104l2.314,6.86,2.315-6.86h1.139Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.528,384.243c0-2.458,1.895-4.293,4.474-4.293,2.555,0,4.449,1.822,4.449,4.293s-1.894,4.294-4.449,4.294c-2.579,0-4.474-1.835-4.474-4.294Zm7.724,0c0-1.858-1.391-3.226-3.25-3.226-1.883,0-3.274,1.367-3.274,3.226s1.392,3.226,3.274,3.226c1.859,0,3.25-1.367,3.25-3.226Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.904,388.441l-1.811-2.579c-.168,.013-.348,.024-.527,.024h-2.075v2.555h-1.199v-8.395h3.274c2.183,0,3.502,1.103,3.502,2.927,0,1.295-.672,2.23-1.847,2.65l1.991,2.818h-1.308Zm-.036-5.469c0-1.2-.804-1.884-2.339-1.884h-2.039v3.778h2.039c1.535,0,2.339-.695,2.339-1.895Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.749,384.711l-1.535,1.56v2.171h-1.199v-8.395h1.199v4.689l4.558-4.689h1.367l-3.586,3.777,3.814,4.618h-1.403l-3.214-3.73Z",
    style: {
      fill: "#071530"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters_5--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.626,371.838c-5.597,0-10.15-4.558-10.15-10.159v-88.181c0-5.597,4.553-10.149,10.15-10.149h106.28c5.597,0,10.15,4.553,10.15,10.149v88.181c0,4.302-2.722,8.153-6.774,9.585l-.432,.145-.027,.002c-.939,.284-1.919,.428-2.917,.428h-106.28Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.626,371.838c-5.597,0-10.15-4.558-10.15-10.159v-88.181c0-5.597,4.553-10.149,10.15-10.149h106.28c5.597,0,10.15,4.553,10.15,10.149v88.181c0,4.302-2.722,8.153-6.774,9.585l-.432,.145-.027,.002c-.939,.284-1.919,.428-2.917,.428h-106.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.056,273.499v88.18c0,3.56-2.27,6.58-5.44,7.7l-.18,.06h-.01c-.79,.26-1.64,.4-2.52,.4h-106.28c-4.5,0-8.15-3.65-8.15-8.16v-88.18c0-4.5,3.65-8.15,8.15-8.15h106.28c4.5,0,8.15,3.65,8.15,8.15Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.472,336.489c-3.608,0-6.428-3.436-5.362-7.209,.328-1.158,1.048-2.197,2.029-2.895,1.43-1.018,3.115-1.282,4.623-.928v-6.859h-8.33c-.36,0-.692-.193-.87-.506-.178-.314-.173-.697,.011-1.007,.449-.75,.594-1.693,.385-2.63-.291-1.304-1.358-2.357-2.661-2.653-2.341-.532-4.426,1.243-4.426,3.495,0,.645,.166,1.263,.479,1.787,.184,.309,.189,.693,.011,1.007-.178,.312-.51,.506-.87,.506h-8.37v20.226c0,2.438,1.976,4.414,4.414,4.414h20.226v-6.898c-.419,.099-.853,.149-1.29,.149Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.063,298.698c3.563,0,6.359,3.352,5.399,7.069-.426,1.651-1.632,3.053-3.215,3.687-1.157,.463-2.375,.536-3.484,.274v6.871h8.33c.358,0,.688,.191,.867,.502,.178,.31,.177,.692-.003,1.001-.542,.932-.638,2.12-.192,3.221,.383,.944,1.204,1.683,2.177,1.983,2.458,.757,4.72-1.07,4.72-3.416,0-.637-.164-1.254-.474-1.787-.18-.309-.181-.691-.003-1.001,.179-.31,.509-.502,.867-.502h8.358v-20.235c0-2.438-1.976-4.414-4.414-4.414h-20.235v6.9c.421-.1,.857-.151,1.3-.151Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.018,352.558c-2.669,2.058-5.374,3.858-8.277,5.565-1.451,.851-2.948,1.659-4.552,2.385-.826,.353-1.648,.713-2.579,1.005-.92,.294-1.957,.565-3.295,.637-.367,.01-.953-.031-1.374-.132-.437-.113-.89-.251-1.23-.438-.18-.09-.368-.183-.532-.282l-.444-.305c-.312-.21-.522-.423-.763-.641-.894-.87-1.451-1.726-1.944-2.561-.966-1.67-1.558-3.305-2.096-4.931-1.004-3.274-1.665-6.473-2.022-9.813-.103-.962,.594-1.824,1.555-1.927,.812-.087,1.554,.397,1.827,1.129l.022,.061c.537,1.442,1.088,2.942,1.682,4.378,.57,1.45,1.183,2.874,1.858,4.225,.649,1.351,1.377,2.659,2.137,3.699,.373,.511,.781,.956,1.081,1.163,.068,.039,.145,.109,.179,.105,.021,.008,.039,.017,.056,.03,.01,0,.008-.018,.008-.018,.011,.014-.044-.047-.096-.049-.031-.024-.209-.041-.179-.042,.083-.03,.164-.052,.246-.069l.123-.02,.192-.069c.27-.109,.496-.146,.813-.303,.584-.242,1.219-.553,1.85-.874,1.274-.694,2.571-1.471,3.868-2.277,2.565-1.655,5.17-3.47,7.65-5.244l.046-.033c1.58-1.13,3.776-.765,4.906,.814,1.104,1.543,.776,3.68-.713,4.831Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.088,345.858c-6.601-1.565-10.995,5.261-19.296,9.665l-.337,7.598s9.197-.377,16.29-7.03c7.093-6.652,3.343-10.233,3.343-10.233Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.745,356.089c-.79,.74-1.61,1.4-2.44,2-1.38,.98-2.79,1.78-4.15,2.42-.41,.19-.82,.37-1.21,.54-2.1,.87-4.04,1.37-5.54,1.67-1.81,.35-2.96,.4-2.96,.4l.35-7.59c8.3-4.41,12.69-11.24,19.29-9.67,0,0,3.75,3.58-3.34,10.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.285,354.756l-1.404-.193-2.448,8.141,3.363,2.165s2.374-6.674,.488-10.113Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.285,354.756l-1.404-.193-2.448,8.141,3.363,2.165s2.374-6.674,.488-10.113Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.396,353.789c-.2,1.32-.58,2.79-1.09,4.3-1.38,.98-2.79,1.78-4.15,2.42-.41,.19-.82,.37-1.21,.54,2.67-4.47,6.45-7.26,6.45-7.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.366,342.999c-.47,1.24,.33,1.5,.33,1.5-1.61,.1-3.73-2.89-1.57-4.36,2.16-1.48,1.11-2.54-.1-4.73-1.2-2.18,1.97-3.68,1.96-6.12-.01-2.43-2.2-2.05-2.2-2.05,.42,2.95-2.1,11.15-8.54,10.61l-.3-.03c-.19-.02-.37-.05-.55-.08-.52-.08-1.03-.18-1.53-.3-1.57-.37-3.07-.92-4.45-1.56-.32-.15-.63-.3-.93-.46-.37-.19-.72-.38-1.07-.59-1.85-1.06-3.4-2.25-4.51-3.31-.55-.52-.99-1-1.3-1.43-1.78-2.43,.89-4.52,2.84-5.07,1.95-.56-.38-3.41,.5-5.16,.87-1.75,3.47-1.9,5.55-1.49,2.09,.41,.72-1.24,3.85-1.57,3.13-.33,9.04,3.38,8.9,5.18,0,0,.16-2.44,3.05-3.28,.74-.21,1.78-.27,2.76-.08v23.31c-1.23,.55-2.39,.27-2.69,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.416,356.985c8.015-5.249,16.435-8.326,16.435-8.326-.499-.149-.032-.057-.549-.193-3.896-1.02-7.091-1.825-10.65-2.246-.896-.104-1.818-.19-2.725-.273v.007c-3.111,4.687-2.512,11.031-2.512,11.031Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M414.806,353.819c-.01,.06-.03,.13-.05,.21-.02,.09-.04,.19-.07,.3-.05,.15-.1,.33-.17,.53-.04,.1-.08,.21-.13,.33v.01c-.09,.24-.2,.5-.33,.79-.04,.09-.09,.18-.13,.28-.1,.21-.21,.43-.33,.68-.08,.14-.16,.3-.24,.46-.33,.62-.65,1.25-.96,1.87-.06,.13-.13,.25-.19,.38-.31,.6-.61,1.21-.9,1.8-.5,1.01-.98,2.01-1.43,2.99-.25,.52-.49,1.04-.71,1.55-.19,.39-.36,.78-.53,1.17v.01c-.32,.71-.63,1.4-.91,2.09-.09,.19-.17,.38-.25,.57h-26.76c.34-2.49,.69-4.99,.94-6.48,.16-1.04,.32-1.95,.46-2.75,.08-.45,.16-.87,.24-1.25v-.01c.09-.42,.17-.8,.25-1.15,.05-.24,.1-.46,.15-.68,.03-.12,.06-.24,.09-.35,.13-.55,.26-1.03,.39-1.49,.17-.64,.33-1.23,.48-1.86v-.01c.07-.28,.15-.56,.24-.84,.07-.22,.15-.45,.24-.67v-.01c.2-.5,.41-.98,.64-1.45,.24-.47,.48-.92,.73-1.35s.5-.83,.75-1.2c.05-.08,.11-.16,.16-.24,.55-.79,1.03-1.41,1.34-1.79,0-.01,.01-.02,.03-.03,.13-.16,.23-.28,.28-.34l.03-.03,.01-.01v-.01c.06,0,.36,.01,.79,.02,.04,0,.08,.01,.13,0,.21,.01,.45,.01,.71,.01,.1,.01,.2,.01,.31,.01h.18c.16,0,.33,.01,.5,.01,.97,.02,1.97,.03,2.58,.04,.3,.01,.51,.02,.56,.02,.86,.08,1.74,.16,2.59,.26,.04,0,.09,0,.13,.01,.17,.02,.34,.04,.5,.07,3.18,.4,6.11,1.12,9.55,2.02,.2,.05,.4,.11,.6,.16,.07,.02,.12,.03,.16,.04,.08,.02,.11,.03,.12,.04l.01,.01c.01,.01,.02,.02,.27,.1,.08,.02,.32,.16,.67,.38,.44,.28,1.06,.69,1.73,1.14q0,.01,.01,.01c.2,.13,.4,.27,.61,.4,1.68,1.13,3.5,2.39,3.89,2.65v.01c.01,0,.01,.01,.02,.01,.01,.01,.02,.01,.02,.02,.01-.01,.01,0,.01,0l.01,.01s.04,.14-.02,.53Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.806,353.819c-.01,.06-.03,.13-.05,.21-.02,.09-.04,.19-.07,.3-.05,.15-.1,.33-.17,.53-.04,.1-.08,.21-.13,.33v.01c-.09,.24-.2,.5-.33,.79-.04,.09-.09,.18-.13,.28-.1,.21-.21,.43-.33,.68-.08,.14-.16,.3-.24,.46-.33,.62-.65,1.25-.96,1.87-.06,.13-.13,.25-.19,.38-.82,1.62-1.6,3.22-2.33,4.79-.24,.52-.47,1.04-.71,1.55v.01c-.18,.39-.35,.77-.53,1.16v.01c-.31,.7-.62,1.4-.91,2.09-.08,.19-.16,.38-.24,.57h-26.77c.34-2.49,.69-4.99,.94-6.48,.16-1.04,.32-1.95,.46-2.75,.09-.45,.17-.86,.24-1.25l.01-.01v-.01c.04-.21,.08-.4,.12-.59,.04-.19,.08-.37,.12-.55,.03-.14,.06-.26,.09-.39,.03-.1,.05-.2,.08-.3,.02-.12,.05-.23,.08-.34,.07-.27,.13-.53,.19-.78,.07-.25,.13-.48,.19-.71,.17-.64,.33-1.23,.48-1.86v-.01c.07-.28,.15-.56,.24-.83v-.01c.08-.23,.16-.45,.24-.67v-.01c.2-.5,.41-.98,.64-1.45,.24-.47,.48-.92,.73-1.35s.5-.83,.75-1.2c.05-.08,.11-.16,.16-.24,.55-.79,1.03-1.41,1.34-1.79h.01c0-.01,.01-.02,.02-.03,.13-.16,.23-.28,.28-.34l.03-.03,.01-.01c.06,0,.36,.01,.79,.01,.04,0,.08,.01,.13,0,.21,.01,.45,.01,.71,.01,.07,.01,.13,.01,.2,.01,.03,0,.07,0,.1-.01,.06,.01,.13,.01,.19,.01,.16,0,.33,.01,.5,.01,.24,0,.49,.01,.73,.01,.73,.01,1.41,.02,1.87,.02h.01c.29,.01,.48,.02,.53,.02,.44,.04,.87,.08,1.3,.13,.44,.04,.86,.09,1.29,.14,.04,0,.09,0,.13,.01,.17,.02,.34,.04,.5,.07,.31,.04,.62,.08,.93,.13,.32,.04,.63,.09,.95,.15,2.49,.41,4.92,1.02,7.67,1.74,.2,.05,.4,.11,.6,.16,.07,.02,.12,.03,.16,.04,.08,.02,.11,.03,.12,.04l.01,.01c.01,.02,.02,.04,.25,.11h.02c.08,.02,.32,.17,.68,.4,.44,.27,1.05,.67,1.72,1.11q0,.01,.01,.01c.2,.13,.4,.27,.61,.4,1.68,1.13,3.5,2.39,3.89,2.65v.01c.01,0,.01,.01,.02,.01h.01c.01,0,.01,.02,.01,.02h.01l.01,.01h.01s.04,.14-.03,.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.008,356.472c-.035,.201,.099,.393,.3,.429s.393-.099,.429-.3-.099-.393-.3-.429-.393,.099-.429,.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.321,363.95c-.035,.201,.099,.393,.3,.429s.393-.099,.429-.3-.099-.393-.3-.429c-.201-.035-.393,.099-.429,.3Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.292,344.946c-9.526-1.703-13.88,4.997-13.88,4.997l4.642-.125s.627,4.292,1.887,5.659c0,0,5.971-.335,9.366-2.916l3.935,1.869s3.62-7.773-5.95-9.483Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.292,344.946c-9.526-1.703-13.88,4.997-13.88,4.997l4.642-.125s.627,4.292,1.887,5.659c0,0,5.971-.335,9.366-2.916l3.935,1.869s3.62-7.773-5.95-9.483Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.004,347.489c-1.854,3.92-.064,7.987-.064,7.987,7.618-1.007,11.774-7.132,11.774-7.132-1.739-2.758,.723-8.793,2.374-12.03l-3.27,1.657-4.865,2.458c-.023,.735-.291,1.701-.672,2.609-.565,1.31-1.375,2.493-2.066,2.653l-3.211,1.797Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28,343.039c1.782-.083,4.34-1.461,5.01-3.149,.278-.713,.471-1.425,.528-1.918l-4.865,2.458c-.023,.735-.291,1.701-.672,2.609Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M413.465,330.058c-2.208,5.314-3.029,7.603-6.747,9.59-5.592,2.989-11.671-.501-11.103-6.274,.511-5.196,4.037-13.012,10.124-13.635,5.997-.613,9.935,5.005,7.726,10.319Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.204,329.487c-.166,.454-.54,.753-.835,.667-.295-.085-.4-.523-.234-.977,.166-.454,.54-.753,.835-.667,.295,.085,.4,.523,.234,.977Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.509,327.647c-.166,.454-.54,.753-.835,.667-.295-.085-.4-.523-.234-.977,.166-.454,.54-.753,.835-.667,.295,.085,.4,.523,.234,.977Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.397,326.734l-.969-.628s.245,1.013,.969,.628Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.898,329.153s-1.481,1.733-2.669,2.432c.391,.732,1.498,.77,1.498,.77l1.171-3.201Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.093,326.888c-.072-.014-.137-.056-.175-.123-.599-1.043-1.633-1.065-1.645-1.066-.153-.003-.271-.127-.258-.281,.013-.153,.149-.276,.305-.275,.054,0,1.353,.028,2.096,1.323,.074,.129,.023,.301-.114,.383-.066,.04-.14,.051-.208,.038Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.247,323.977c-.07-.004-.136-.034-.183-.089-.097-.113-.077-.288,.045-.392,1.223-1.039,2.465-.738,2.518-.724,.148,.038,.228,.189,.179,.337-.049,.148-.209,.238-.356,.201-.048-.013-1.016-.232-1.988,.594-.063,.053-.141,.077-.214,.073Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.092,328.573l-.969-.628s.245,1.013,.969,.628Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.064,332.762s-2.022-4.44,1.082-9.938c0,0-5.625-4.062-11.083-.329,0,0,5.668-6.839,14.077-1.608,8.409,5.231,.059,12.719-1.187,13.245-1.247,.526-2.888-1.37-2.888-1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.729,335.032c-.996,.92-2.266,1.297-3.304,1.238-1.561-.089-1.729-1.711-.782-3.007,.852-1.167,2.692-2.527,4.012-1.802,1.301,.714,1.213,2.519,.074,3.571Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.18,333.583c.231,.824,.352,2.32,.352,2.32,.137,.013,.275,.027,.413,.033,1.869,.136,2.781-.418,3.225-1.074,.242-.36,.339-.755,.376-1.08,.046-.376-.006-.654-.006-.654-1.034,.52-2.785,.527-3.721,.492-.392-.011-.638-.036-.638-.036Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.818,333.619l.122,.681c1.76,.124,3.016-.025,3.606-.519,.046-.376-.006-.654-.006-.654-1.034,.52-2.785,.527-3.721,.492Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.945,335.936c1.869,.136,2.781-.418,3.225-1.074-.639-.022-1.411,.023-2.105,.26-.531,.179-.88,.49-1.12,.814Z",
    style: {
      fill: "#de5753"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360.625,342.278l.094-5.54,5.499,2.744s-.382,4.938-2.918,4.634l-2.675-1.838Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.626 332.354 367.58 336.063 366.218 339.481 360.719 336.737 363.626 332.354",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.458,334.687c-1.193,2.842-4.476,4.184-7.318,2.991s-4.184-4.476-2.991-7.318c.169-.403,.383-.784,.637-1.132l-6.334-2.659-3.22,7.672c-.138,.329-.443,.561-.798,.605-.355,.045-.707-.103-.922-.39-.634-.84-1.659-1.383-2.801-1.419-1.266-.04-2.482,.659-3.129,1.748-1.14,1.917-.294,4.33,1.687,5.162,.586,.246,1.219,.334,1.832,.254,.355-.047,.707,.1,.925,.385,.217,.285,.265,.664,.127,.994l-3.235,7.708,18.658,7.832c2.248,.943,4.835-.114,5.778-2.362l7.828-18.649-6.36-2.67c-.071,.424-.193,.844-.362,1.247Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M392.603,355.978l-2.171-5.098-4.063,4.611s2.212,4.432,4.447,3.196l1.787-2.709Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.969 347.686 383.822 352.837 386.37 355.491 390.432 350.88 385.969 347.686",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.636,367.169v.01c-.31,.7-.62,1.4-.91,2.09-.08,.19-.16,.38-.24,.57h-8.62c.13-2.32,.75-3.83,.75-3.83l.64,.25,2.35,.93c.74-2.76,1.7-4.85,2.45-6.23v-.01c.71-1.29,1.23-1.96,1.23-1.96,0,0,.25,.77,.63,2.04,.45,1.49,1.08,3.68,1.72,6.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.162,366.005c.931-2.06,1.944-4.187,3.045-6.349-.458-1.035-1.048-1.951-1.777-2.597,0,0-2.423,5.351-1.268,8.946Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.386,355.199v-.01c-.48-.74-1.25-1.3-2.18-1.51-1.89-.42-3.77,.77-4.19,2.67l-.03,.11c-.32,1.43-.65,3-1.05,4.47-.01,.03-.02,.07-.02,.1-.36,1.46-.76,2.9-1.23,4.26-.48,1.36-1,2.75-1.58,3.66-.06,.12-.14,.22-.2,.31-.04,.05-.07,.09-.1,.13-.28-.13-.64-.36-1-.64-.03-.02-.05-.04-.08-.06-.45-.36-.92-.8-1.37-1.26l-.14-.14c-.33-.33-.65-.67-.96-1.03-.68-.76-1.33-1.59-2-2.42-.96-1.22-1.88-2.5-2.78-3.8-.93-1.28-1.81-2.63-2.68-3.93v-.01l-.03-.05c-.07-.11-.16-.21-.26-.3-.3-.29-.71-.45-1.13-.47-.22-.01-.46,.03-.68,.11-.91,.34-1.36,1.35-1.02,2.26,.16,.42,.32,.84,.49,1.25,1.08,2.69,2.35,5.26,3.81,7.82,.6,1.06,1.26,2.09,1.99,3.12h15.27c.36-.73,.66-1.45,.94-2.17,1.27-3.32,2.13-6.52,2.73-9.95,.16-.9-.05-1.79-.52-2.52Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.376,369.839h-8.72l.15-1.09,.07-.46c.12-.16,.25-.45,.39-.82,.73-1.89,1.66-5.92,1.79-6.51v-.01c.02-.04,.02-.06,.02-.06,3.4-10.64,9.01-8.01,9.69-7.64,.01,0,.01,.01,.02,.01h.01c.01,0,.01,.02,.01,.02h.01l.01,.01h.01s2.07,5.46-3.46,16.55Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.376,369.839h-8.72l.15-1.09,.07-.46c.12-.16,.25-.45,.39-.82,.73-1.89,1.66-5.92,1.79-6.51v-.01c.02-.04,.02-.06,.02-.06,3.4-10.64,9.01-8.01,9.69-7.64,.01,0,.01,.01,.02,.01h.01c.01,0,.01,.02,.01,.02h.01l.01,.01h.01s2.07,5.46-3.46,16.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.086,369.839h-2.67c.06-.85,.06-1.69-.06-2.41,0-.07-.01-.13-.02-.2h1.83s.04,.08,.1,.24c.13,.32,.38,.96,.64,1.79,.03,.07,.05,.14,.07,.21,0,.02,.01,.03,.01,.05,.04,.1,.07,.21,.1,.32Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.086,369.839h-2.67c.06-.85,.06-1.69-.06-2.41,0-.07-.01-.13-.02-.2h1.83s.04,.08,.1,.24c.13,.32,.38,.96,.64,1.79,.03,.07,.05,.14,.07,.21,0,.02,.01,.03,.01,.05,.04,.1,.07,.21,.1,.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.64,305.04c1.277,1.414,2.641,2.95,4.016,4.364,1.367,1.443,2.745,2.866,4.166,4.186,1.422,1.305,2.863,2.587,4.277,3.588,.701,.493,1.404,.925,1.958,1.19,.287,.148,.491,.199,.608,.252,.048,.01,.005,.065,.204,.04,.377-.042,1.104-.302,1.826-.667,.735-.374,1.507-.847,2.276-1.373,1.548-1.046,3.091-2.275,4.611-3.557,3.023-2.58,6.039-5.389,8.932-8.209l3.248,2.616c-2.365,3.57-4.908,6.914-7.821,10.102-1.459,1.591-2.995,3.137-4.736,4.605-.877,.729-1.807,1.438-2.859,2.109-1.068,.662-2.226,1.318-3.873,1.735-.812,.214-1.9,.29-2.879,.175-.902-.123-1.704-.337-2.372-.588-1.371-.498-2.469-1.108-3.5-1.742-2.049-1.27-3.791-2.654-5.452-4.106-3.326-2.905-6.255-5.917-9.067-9.291l6.437-5.427Z",
    style: {
      fill: "#e7b278"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.606,307.818l4.905-6.299-6.121-3.354s-4.048,3.921-2.245,8.206l3.461,1.447Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.675 295.579 350.809 294.099 350.39 298.165 356.512 301.519 354.675 295.579",
    style: {
      fill: "#ebb376"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.512,301.519l-1.837-5.94-3.866-1.48-.418,4.066s-3.501,3.397-2.533,7.322c-2.693,2.606-5.479,5.189-8.275,7.576-1.52,1.282-3.063,2.511-4.611,3.557-.768,.527-1.541,1-2.276,1.373-.722,.365-1.449,.625-1.826,.667-.199,.024-.157-.031-.204-.04-.117-.053-.321-.104-.608-.252-.554-.265-1.257-.697-1.958-1.19-1.414-1.001-2.855-2.283-4.277-3.588-1.421-1.321-2.799-2.744-4.166-4.186-1.375-1.414-2.739-2.95-4.016-4.364l-6.437,5.427c2.812,3.374,5.741,6.386,9.067,9.291,1.661,1.452,3.404,2.836,5.452,4.106,1.032,.635,2.13,1.244,3.5,1.742,.668,.251,1.47,.465,2.372,.588,.979,.115,2.067,.038,2.879-.175,1.646-.417,2.804-1.073,3.873-1.735,1.052-.671,1.982-1.38,2.859-2.109,1.741-1.468,3.278-3.014,4.736-4.605,2.825-3.091,5.297-6.332,7.601-9.78l.064,.027,4.905-6.299Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.342,305.997c4.291,2.678,10.418,10.793,10.418,10.793l-9.191,8.121-11.091-7.241,9.863-11.673Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.756,316.789l-9.19,8.12-6.83-4.46-3.46-2.26-.8-.52,1.05-1.24,3.9-4.61,4.92-5.82c4.29,2.68,10.41,10.79,10.41,10.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.736,320.449l-3.46-2.26c.08-.61,.17-1.2,.25-1.76l3.9-4.61s.79,3.81-.69,8.63Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.346,305.999c-.27,.39-.53,.78-.79,1.17-.19,.27-.37,.54-.56,.82-.5,.76-.99,1.52-1.47,2.29-.46,.73-.9,1.45-1.33,2.18-.2,.33-.39,.66-.59,.99v.01c-.21,.35-.42,.71-.62,1.06-.02,.04-.04,.07-.06,.11-.18,.32-.36,.64-.54,.96-.26,.46-.52,.92-.77,1.38-.37,.68-.74,1.36-1.09,2.03h-.01v.01c-.6,1.14-1.18,2.28-1.74,3.41-.16,.32-.32,.63-.47,.94-.05,.1-.1,.2-.14,.29-.07,.14-.14,.28-.2,.42-.18,.37-.36,.74-.53,1.11-.24,.51-.48,1.01-.71,1.52-.17,.36-.34,.72-.5,1.07-.06,.15-.13,.29-.19,.43-.16,.36-.32,.73-.49,1.09-.27,.62-.54,1.23-.8,1.84-.38,.88-.75,1.75-1.1,2.61-.23,.55-.45,1.08-.67,1.61-1.37,3.37-2.53,6.46-3.5,9.11v-48.38c.19,.08,.38,.16,.58,.24h.01c.05,.02,.1,.04,.15,.07,.31,.13,.63,.26,.95,.39,1.05,.46,2.14,.95,3.2,1.44,.84,.39,1.66,.77,2.44,1.15,.51,.24,1.01,.48,1.48,.71,.26,.13,.51,.25,.75,.37,.01,0,.01,.01,.02,.01,.05,.03,.11,.05,.16,.08,.71,.35,1.43,.73,2.11,1.11,.13,.07,.25,.14,.38,.22l.01,.01c3.64,2.02,6.63,4.12,6.63,4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.346,305.999c-.27,.39-.53,.77-.8,1.16-.18,.28-.37,.56-.55,.83-.5,.76-.99,1.52-1.47,2.29-.45,.72-.9,1.45-1.33,2.18-.2,.33-.39,.66-.59,.99v.01c-.21,.35-.42,.71-.62,1.06-.02,.04-.04,.07-.06,.11-.18,.32-.36,.64-.54,.96-.26,.46-.52,.92-.77,1.38-.37,.68-.74,1.36-1.09,2.03v.01h-.01c-.6,1.14-1.18,2.28-1.74,3.41-.16,.32-.32,.63-.47,.94-.05,.1-.1,.2-.14,.29-.07,.14-.14,.28-.2,.42-.18,.37-.36,.74-.53,1.11-.24,.51-.48,1.01-.71,1.52-.17,.36-.33,.71-.49,1.07-.07,.14-.13,.28-.2,.43-.16,.36-.32,.73-.49,1.09-.27,.62-.54,1.23-.8,1.84-.38,.88-.75,1.75-1.1,2.61-.23,.55-.45,1.08-.67,1.61-1.37,3.37-2.53,6.46-3.5,9.11v-48.38c.19,.08,.38,.16,.58,.24h.01c.05,.02,.1,.04,.15,.07,.31,.13,.63,.26,.95,.39,1.05,.46,2.14,.95,3.2,1.44,.84,.39,1.66,.77,2.44,1.15,.51,.24,1.01,.48,1.48,.71,.26,.13,.51,.25,.75,.37,.01,0,.01,.01,.02,.01,.05,.03,.11,.05,.16,.08,.71,.35,1.43,.73,2.11,1.11,.13,.07,.25,.14,.38,.22l.01,.01c3.64,2.02,6.63,4.12,6.63,4.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.286,300.749c.3,.8,.88,1.63,1.81,2.48,0,0-2.81,1.85-4.3,1.46-1.82-.48-6.13-6.03-7.32-7.61v-.52c.19-.06,.39-.14,.58-.24h.01c.25-.13,.5-.28,.75-.45,1.43-.98,2.72-2.66,3.82-4.54,.25-.45,.5-.91,.74-1.37v-.01c.13-.26,.26-.52,.38-.78,.51-1.04,.95-2.08,1.33-3.06,.08-.2,.15-.39,.22-.58,.14-.37,.27-.73,.39-1.08,.06-.17,.12-.34,.17-.5l.63,1.7v.01l.09,.21,.04,.1v.01l3.07,8.23c-.41,.44-.81,.89-1.16,1.35-.12,.16-.23,.31-.34,.47-.11,.16-.22,.32-.31,.48-.1,.16-.19,.32-.28,.49-.08,.16-.16,.33-.22,.49-.02,.03-.03,.06-.04,.1-.05,.14-.1,.27-.14,.41-.03,.1-.06,.2-.08,.31-.1,.42-.14,.85-.1,1.29,.01,.11,.02,.22,.04,.33v.01c.03,.2,.08,.4,.15,.6,.02,.07,.04,.14,.07,.21Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.375,289.95l-.002,.008c-.381,3.921,.075,8.69,3.914,10.789-.918-2.414,.6-4.628,2.406-6.539l-3.827-10.257c-.557,1.692-1.409,3.899-2.491,5.999Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.796,304.689s-2.13,1.09-4.51,2.06c-.74-.85-1.83-2.19-2.81-3.7v-7.47c.69,.01,1.28,.1,1.28,.1,0,0,.02,.07,.06,.19,.06,.19,.17,.5,.35,.91,.66,1.57,2.27,4.63,5.63,7.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,304.689s1.298,2.241,1.768,4.61c2.254-.43,3.642-6.432,3.24-7.322-1.067-1.423-2.745-2.051-2.745-2.051,0,0,.227,3.079-2.263,4.763Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.796,304.689s-2.13,1.09-4.51,2.06c-.74-.85-1.83-2.19-2.81-3.7v-7.47c.69,.01,1.28,.1,1.28,.1,0,0,.02,.07,.06,.19,.06,.19,.17,.5,.35,.91,.66,1.57,2.27,4.63,5.63,7.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,304.689s1.298,2.241,1.768,4.61c2.254-.43,3.642-6.432,3.24-7.322-1.067-1.423-2.745-2.051-2.745-2.051,0,0,.227,3.079-2.263,4.763Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.216,282.112c.028,2.567-1.836,7.259-4.636,4.702-2.8-2.557,4.588-9.114,4.636-4.702Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.369,280.163c-2.185,5.914-3.767,9.267-2.144,13.481,2.441,6.338,10.758,6.77,14.677,1.613,3.528-4.642,6.509-13.534,1.848-18.262-4.593-4.658-12.195-2.746-14.38,3.169Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.449,285.546c-.207,.469-.125,.957,.184,1.089,.309,.132,.726-.14,.933-.61,.207-.469,.124-.957-.184-1.089-.309-.133-.726,.14-.933,.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.783,287.835c-.207,.469-.124,.957,.184,1.089,.308,.132,.726-.14,.933-.61,.207-.469,.124-.957-.184-1.089-.309-.132-.726,.141-.933,.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.984,287.341s-.049,3.078,.585,4.854c-1.147,.379-2.409-.585-2.409-.585l1.824-4.269Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.56,283.128c.09,.054,.207,.059,.306,.004,1.178-.66,2.171-.163,2.181-.158,.148,.076,.331,.019,.409-.128,.077-.147,.02-.328-.127-.404-.052-.027-1.297-.65-2.758,.169-.146,.082-.198,.265-.117,.409,.026,.047,.064,.083,.107,.109Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.885,286.998c.049,.03,.107,.045,.169,.042,.167-.007,.297-.148,.291-.313-.065-1.661-1.258-2.367-1.307-2.406-.143-.084-.329-.037-.415,.106-.085,.142-.039,.325,.102,.41,.051,.028,.963,.583,1.015,1.917,.004,.104,.061,.194,.145,.244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.448,279.398s-1.112-1.82-2.361-.902c-1.249,.919-2.607,4.224-2.607,4.224l-.075-.717s-5.171,6.44-7.369,3.325c-2.198-3.115-3.415-12.408,5.167-13.224,0,0,1.494-1.451,6.469-.357,4.975,1.094,9.329,6.306,8.984,9.755s-2.404,4.574-2.404,4.574c.22-1.209-.115-2.181-.115-2.181-.526,.94-1.745,.911-1.745,.911,.536-1.19,.39-1.956,.39-1.956-.364,.614-1.393,1.136-1.393,1.136,1.001-3.276-.856-4.823-1.541-5.085-.843-.322-1.401,.498-1.401,.498Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.03,283.983c-.193,1.685,.416,3.298,1.308,4.369,1.342,1.611,3.219,.7,3.856-1.186,.573-1.698,.566-4.582-1.267-5.507-1.805-.911-3.676,.397-3.897,2.324Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.149,293.474c-.802,.296-2.081,1.075-2.081,1.075-.091-.103-.183-.206-.269-.314-1.205-1.43-1.292-2.492-1.022-3.235,.149-.406,.411-.717,.652-.937,.277-.258,.533-.378,.533-.378,.186,1.14,1.207,2.56,1.784,3.295,.238,.31,.403,.494,.403,.494Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.746,292.98l-.622,.301c-1.132-1.35-1.748-2.452-1.695-3.218,.277-.258,.533-.378,.533-.378,.186,1.14,1.207,2.56,1.784,3.295Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.799,294.235c-1.205-1.43-1.292-2.492-1.022-3.235,.392,.503,.808,1.154,1.023,1.853,.167,.534,.119,.999-.001,1.382Z",
    style: {
      fill: "#a24e3f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M340.745,319.438c-.991-2.823,.427-5.918,3.171-7.031,2.528-1.025,5.556-.017,6.925,2.343,.411,.709,.66,1.483,.742,2.26l6.474-2.273-2.763-7.869c-.119-.34-.047-.717,.19-.988,.236-.272,.6-.395,.953-.323,.853,.174,1.787,.001,2.601-.502,1.136-.703,1.78-2.055,1.631-3.383-.267-2.392-2.637-3.777-4.765-3.03-.609,.214-1.137,.575-1.528,1.044-.23,.276-.591,.407-.946,.343-.354-.064-.647-.313-.766-.653l-2.773-7.897-19.084,6.701c-2.3,.808-3.51,3.327-2.702,5.627l6.704,19.093,6.511-2.286c-.233-.364-.426-.759-.573-1.176Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.745,319.438c-.991-2.823,.427-5.918,3.171-7.031,2.528-1.025,5.556-.017,6.925,2.343,.411,.709,.66,1.483,.742,2.26l6.474-2.273-2.763-7.869c-.119-.34-.047-.717,.19-.988,.236-.272,.6-.395,.953-.323,.853,.174,1.787,.001,2.601-.502,1.136-.703,1.78-2.055,1.631-3.383-.267-2.392-2.637-3.777-4.765-3.03-.609,.214-1.137,.575-1.528,1.044-.23,.276-.591,.407-.946,.343-.354-.064-.647-.313-.766-.653l-2.773-7.897-19.084,6.701c-2.3,.808-3.51,3.327-2.702,5.627l6.704,19.093,6.511-2.286c-.233-.364-.426-.759-.573-1.176Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.624,323.768l5.153-6.098,4.543,5.299s-3.003,4.769-7.567,3.888l-2.129-3.088Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.053 315.56 338.494 320.32 335.32 322.969 330.777 317.67 336.053 315.56",
    style: {
      fill: "#ebb376"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.076,327.489c-1.29,.2-2.57,.29-3.84,.28h-.01c-1.77-.01-3.51-.21-5.2-.56-.52-.11-1.04-.23-1.55-.37v-19.74c.63,.19,1.15,.42,1.5,.72,.42,.35,.81,.75,1.18,1.19,3.12,3.66,4.64,9.91,4.64,9.91l-1.53,.77,1.33,2.15,1.37,2.23,2.11,3.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.886,326.559c-.48,.13-.96,.26-1.44,.39-3.79,1-7.59,1.76-11.52,2.26-2.21,.27-4.45,.48-6.81,.47-1.18-.01-2.39-.06-3.7-.24-.28-.04-.57-.09-.87-.15-.38-.08-.78-.18-1.21-.31l-.56-.18c-.2-.07-.41-.16-.61-.25-.38-.14-.86-.43-1.29-.7-.31-.22-.59-.43-.85-.64-.6-.48-1.09-.94-1.55-1.41v-13.56c.04,.07,.08,.13,.12,.2,1.11,1.76,2.22,3.51,3.36,5.16,.3,.43,.6,.85,.91,1.26,.28,.37,.56,.73,.83,1.08,.56,.71,1.21,1.4,1.56,1.71,0,.03,.13,.1,.34,.19,.28,.12,.7,.27,1.15,.37,.33,.08,.67,.15,1.03,.21,.53,.09,1.1,.17,1.68,.22,1.91,.19,3.96,.26,6.02,.25h.05c1.79,0,3.62-.04,5.45-.11,.03,.01,.06,.01,.1,0,1.51-.04,3.03-.11,4.54-.18,.85-.05,1.7-.09,2.54-.14l.67,3.76,.06,.34Z",
    style: {
      fill: "#e7b278"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.766,317.979l-1.9,.88-4.39,2.04v-16.77c.97,1.49,1.88,3.19,2.68,4.88,2.17,4.54,3.61,8.97,3.61,8.97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.766,317.979l-1.9,.88-4.39,2.04v-16.77c.97,1.49,1.88,3.19,2.68,4.88,2.17,4.54,3.61,8.97,3.61,8.97Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Problem_solving--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.562,382.973c0,1.822-1.319,2.926-3.502,2.926h-2.075v2.543h-1.199v-8.396h3.275c2.183,0,3.502,1.103,3.502,2.928Zm-1.199,0c0-1.2-.804-1.884-2.339-1.884h-2.039v3.767h2.039c1.535,0,2.339-.684,2.339-1.883Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.942,388.441l-1.811-2.579c-.168,.013-.348,.024-.527,.024h-2.075v2.555h-1.199v-8.396h3.274c2.183,0,3.502,1.103,3.502,2.928,0,1.295-.672,2.23-1.847,2.65l1.991,2.818h-1.308Zm-.036-5.469c0-1.2-.804-1.884-2.339-1.884h-2.039v3.778h2.039c1.535,0,2.339-.695,2.339-1.895Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.37,384.243c0-2.458,1.895-4.294,4.474-4.294,2.555,0,4.449,1.823,4.449,4.294s-1.895,4.294-4.449,4.294c-2.579,0-4.474-1.836-4.474-4.294Zm7.724,0c0-1.858-1.391-3.226-3.25-3.226-1.883,0-3.275,1.367-3.275,3.226s1.392,3.226,3.275,3.226c1.859,0,3.25-1.367,3.25-3.226Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.354,386.174c0,1.44-1.091,2.268-3.214,2.268h-4.006v-8.396h3.766c1.931,0,3.01,.816,3.01,2.172,0,.911-.468,1.547-1.128,1.871,.947,.264,1.571,.971,1.571,2.086Zm-6.021-5.156v2.686h2.459c1.223,0,1.919-.455,1.919-1.343s-.696-1.343-1.919-1.343h-2.459Zm4.81,5.061c0-.971-.72-1.403-2.051-1.403h-2.759v2.794h2.759c1.331,0,2.051-.419,2.051-1.391Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.217,380.045h1.199v7.353h4.546v1.044h-5.745v-8.396Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.438,387.397v1.044h-6.093v-8.396h5.925v1.044h-4.726v2.579h4.21v1.02h-4.21v2.71h4.894Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.169,388.441l-.012-6.117-3.035,5.098h-.552l-3.034-5.061v6.081h-1.151v-8.396h.983l3.502,5.901,3.454-5.901h.984l.012,8.396h-1.151Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.305,387.481l.444-.935c.624,.563,1.691,.972,2.771,.972,1.451,0,2.075-.564,2.075-1.295,0-2.051-5.085-.756-5.085-3.875,0-1.295,1.007-2.399,3.214-2.399,.983,0,2.003,.264,2.699,.744l-.396,.959c-.731-.467-1.559-.683-2.303-.683-1.427,0-2.038,.6-2.038,1.332,0,2.051,5.085,.768,5.085,3.85,0,1.283-1.031,2.387-3.25,2.387-1.283,0-2.542-.432-3.214-1.056Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.841,384.243c0-2.458,1.895-4.294,4.474-4.294,2.555,0,4.449,1.823,4.449,4.294s-1.895,4.294-4.449,4.294c-2.579,0-4.474-1.836-4.474-4.294Zm7.724,0c0-1.858-1.391-3.226-3.25-3.226-1.883,0-3.274,1.367-3.274,3.226s1.392,3.226,3.274,3.226c1.859,0,3.25-1.367,3.25-3.226Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.604,380.045h1.199v7.353h4.545v1.044h-5.745v-8.396Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.401,380.045l-3.682,8.396h-1.187l-3.694-8.396h1.295l3.023,6.896,3.046-6.896h1.199Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.473,380.045h1.199v8.396h-1.199v-8.396Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.413,380.045v8.396h-.983l-5.038-6.262v6.262h-1.199v-8.396h.983l5.037,6.262v-6.262h1.2Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.753,384.195h1.151v3.274c-.84,.709-2.003,1.068-3.178,1.068-2.579,0-4.474-1.81-4.474-4.294s1.895-4.294,4.498-4.294c1.331,0,2.458,.444,3.226,1.295l-.744,.744c-.695-.672-1.487-.971-2.435-.971-1.943,0-3.346,1.355-3.346,3.226,0,1.847,1.403,3.226,3.334,3.226,.708,0,1.367-.155,1.967-.539v-2.734Z",
    style: {
      fill: "#071530"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_4--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.089,371.839c-5.597,0-10.15-4.558-10.15-10.16v-88.18c0-5.597,4.553-10.15,10.15-10.15h106.28c5.602,0,10.16,4.553,10.16,10.15v88.18c0,1.496-.322,2.945-.958,4.306-.09,.205-.208,.431-.328,.643l-.103,.176c-.079,.136-.158,.271-.249,.406-1.861,2.889-5.054,4.629-8.523,4.629H86.089Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.089,371.839c-5.597,0-10.15-4.558-10.15-10.16v-88.18c0-5.597,4.553-10.15,10.15-10.15h106.28c5.602,0,10.16,4.553,10.16,10.15v88.18c0,1.496-.322,2.945-.958,4.306-.09,.205-.208,.431-.328,.643l-.103,.176c-.079,.136-.158,.271-.249,.406-1.861,2.889-5.054,4.629-8.523,4.629H86.089Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,273.499v88.18c0,1.24-.28,2.41-.77,3.46-.08,.18-.17,.35-.26,.51-.09,.15-.17,.3-.27,.45-1.45,2.25-3.98,3.74-6.86,3.74H86.089c-4.5,0-8.15-3.65-8.15-8.16v-88.18c0-4.5,3.65-8.15,8.15-8.15h106.28c4.5,0,8.16,3.65,8.16,8.15Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.14,339.169c-.563,3.408-1.324,6.648-2.324,9.959-.493,1.654-1.056,3.3-1.784,4.978-.365,.841-.762,1.69-1.287,2.57-.268,.444-.553,.892-.927,1.369-.184,.237-.38,.477-.634,.734-.176,.199-.639,.632-1.049,.882-.853,.547-1.712,.764-2.44,.861-.736,.095-1.365,.055-1.944-.01-1.153-.142-2.106-.43-3.013-.744-1.794-.648-3.358-1.462-4.866-2.329-2.993-1.775-5.714-3.715-8.312-5.952-.733-.631-.815-1.736-.184-2.469,.537-.623,1.418-.776,2.12-.418l.054,.028c1.411,.719,2.865,1.475,4.315,2.153,1.438,.708,2.891,1.371,4.342,1.949,1.44,.586,2.894,1.111,4.245,1.436,.665,.161,1.32,.267,1.808,.264,.5,.026,.744-.182,.378-.029-.267,.182-.092,.04,.012-.159,.117-.183,.254-.443,.388-.716,.267-.562,.535-1.221,.782-1.906,.491-1.378,.914-2.876,1.322-4.385,.78-3.023,1.449-6.213,2.071-9.276l.013-.065c.386-1.903,2.242-3.133,4.145-2.746,1.859,.377,3.074,2.163,2.77,4.019Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.618,334.225c-5.892,3.362-4.445,11.349-7.506,20.234l4.94,5.783s6.464-6.553,7.108-16.257c.644-9.703-4.542-9.76-4.542-9.76Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.118,354.461l4.93,5.784s.807-.817,1.888-2.314c1.055-1.472,2.378-3.591,3.426-6.22,.896-2.236,1.602-4.843,1.802-7.725,.641-9.7-4.542-9.756-4.542-9.756-5.896,3.355-4.449,11.345-7.503,20.232Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95,353.561l-1.158,.817,3.768,7.62,3.936-.713s-2.821-6.498-6.546-7.724Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95,353.561l-1.158,.817,3.768,7.62,3.936-.713s-2.821-6.498-6.546-7.724Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.936,357.931c1.055-1.472,2.378-3.591,3.426-6.22-.315-2.413-.82-4.75-1.518-6.585,0,0-2.806,6.22-1.908,12.805Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.643,303.976c-1.104-1.418-7.975-.174-10.064,2.186-2.089,2.36,.033,2.652-1.778,3.756-1.811,1.104-3.632,2.965-3.095,4.847,.537,1.883,4.178,2.423,3.11,4.146-1.067,1.723-1.62,5.062,1.333,5.656s10.321-.078,15.793-3.972c5.472-3.894,1.724-11.85-.608-13.775,0,0,1.352-1.758,3.006,.032,1.654,1.79,.323,5.04,2.685,5.838,2.362,.798,3.859,.876,3.26,3.42-.598,2.544,2.984,3.317,4.103,2.161,0,0-.76,.348-1.258-.881-.497-1.229,2.256-1.922,1.406-5.362-.85-3.44-3.15-2.36-3.284-4.027s1.883-2.383,.294-4.881c-1.159-1.822-4.773-1.569-6.299-2.349-1.527-.78-.573-2.246-3.3-3.669-1.815-.947-4.369,.925-5.269,2.402-1.563,2.564-.035,4.471-.035,4.471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.936,343.367c3.731-8.155,9.989-15.013,9.989-15.013-.502,.119-1.015,.251-1.524,.388-3.837,1.046-6.965,1.929-10.181,3.303-.808,.347-1.628,.722-2.434,1.091l.003,.007c.054,5.329,4.147,10.224,4.147,10.224Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.759,365.139c-.08,.18-.17,.35-.26,.51-.09,.15-.17,.3-.27,.45-1.45,2.25-3.98,3.74-6.86,3.74h-16.55c-.15-1.63-.28-3.31-.31-3.62v-.05l23.64-2.66,.01,.01v.01l.6,1.61Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.499,365.649c-.09,.15-.17,.3-.27,.45l-3.13,.4h-.02l-5.63,.72h-.03l-3.83,.48-3.14,.4-7.39,.94-.4-2.19h.01l23.3-2.91h.04l.49,1.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.754,368.466c-.325,0-.61-.232-.668-.559l-.245-1.353c-.034-.186,.012-.38,.126-.531,.114-.151,.287-.249,.476-.268l2.567-.262c.182-.024,.358,.035,.499,.149,.141,.115,.229,.278,.247,.459l.132,1.303c.038,.372-.222,.698-.592,.745l-2.455,.311c-.029,.003-.058,.005-.087,.005Zm2.324-2.517h-.022l-2.567,.263c-.062,.007-.117,.037-.155,.087s-.052,.111-.041,.173l.245,1.352c.021,.115,.127,.207,.246,.18l2.455-.311c.12-.015,.205-.121,.192-.241l-.132-1.303c-.012-.114-.108-.199-.22-.199Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.152,363.511c-.506-5.573-.364-15.98,1.104-27.149,.478-3.632-.7-5.84-.7-5.84,0,0-6.013-.614-6.487-.581-.52,.033-1.053,.077-1.586,.127-4.008,.391-7.285,.74-10.77,1.578-.876,.212-1.771,.451-2.651,.686-.283,.082-5.17,1.813-5.445,1.893,0,0-1.893,4.819-1.415,9.017,.272,2.345,.242,4.157,1.372,9.678,.704,3.761,3.087,13.927,3.087,13.927,1.436,3.837,9.082-.726,9.082-.726,12.716,3.664,14.408-2.611,14.408-2.611Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.572,352.917c.712,3.763,3.093,13.932,3.093,13.932,1.437,3.835,9.075-.73,9.075-.73,12.718,3.671,14.415-2.612,14.415-2.612-.358-3.939-.392-10.295,.14-17.627,.161-2.255,.376-4.601,.661-7.01,.084-.828,.187-1.66,.299-2.503,.48-3.634-.694-5.85-.694-5.85,0,0-6.015-.607-6.486-.573-.522,.034-1.055,.069-1.593,.126-4.004,.39-7.284,.74-10.771,1.576-.877,.21-1.768,.452-2.651,.683-.28,.081-5.168,1.821-5.438,1.9,0,0-1.892,4.814-1.415,9.017,.271,2.339,.244,4.153,1.366,9.671Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.78,342.179c.036,.201,.229,.335,.43,.298,.201-.036,.335-.229,.298-.43-.037-.201-.229-.335-.43-.298-.201,.036-.335,.229-.298,.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.845,350.124c.036,.201,.229,.335,.43,.298,.201-.036,.335-.229,.298-.43-.036-.201-.229-.335-.43-.298-.201,.037-.335,.229-.298,.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.813,357.54c.036,.201,.229,.335,.43,.298,.201-.037,.335-.229,.298-.43-.036-.201-.229-.335-.43-.298-.201,.037-.335,.229-.298,.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.73,364.679c.036,.201,.229,.335,.43,.298,.201-.036,.335-.229,.298-.43-.036-.201-.229-.335-.43-.298-.201,.036-.335,.229-.298,.43Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.215,328.283c-8.932,3.204-8.781,10.779-8.781,10.779l3.812-2.342s2.956,3.205,4.783,3.713c0,0,4.805-3.155,6.184-6.901l4.35-.372s-1.374-8.097-10.348-4.878Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.215,328.283c-8.932,3.204-8.781,10.779-8.781,10.779l3.812-2.342s2.956,3.205,4.783,3.713c0,0,4.805-3.155,6.184-6.901l4.35-.372s-1.374-8.097-10.348-4.878Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M187.879,328.989c0,.09-.02,6.45-5.88,10.75,0,0-3.89-2.11-4.58-5.84l1.69-2.82c.21-.19,.34-.54,.39-.97,.05-.55-.01-1.25-.17-1.94-.21-.84-.54-1.66-.94-2.21l2.71-4.09,.24-.37,1.59-2.38c.47,3.14,1.87,8.69,4.95,9.87Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.499,330.109c.05-.55-.01-1.25-.17-1.94-.21-.84-.54-1.66-.94-2.21l2.71-4.09,.24-.37c.35,.57,.7,1.44,.95,2.36,.53,1.99-.97,4.72-2.79,6.25Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.044,311.819c1.956,5.412,2.895,7.655,1.493,11.63-2.11,5.98-8.951,7.506-12.428,2.863-3.129-4.179-5.802-12.327-1.73-16.894,4.012-4.5,10.709-3.011,12.665,2.401Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,316.298c.184,.447,.109,.92-.166,1.056-.275,.136-.648-.116-.831-.563-.184-.447-.11-.92,.166-1.056,.275-.136,.648,.116,.832,.563Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.856,318.784c.184,.447,.11,.92-.166,1.056s-.648-.116-.832-.563c-.184-.447-.11-.92,.166-1.056,.275-.136,.648,.116,.832,.563Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.156,318.186l-1.139,.191s.864,.582,1.139-.191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.897,318.957s.076,2.278-.329,3.596c.783,.276,1.625-.443,1.625-.443l-1.296-3.152Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94,313.105c-.063,.038-.139,.05-.212,.027-1.146-.365-1.925,.316-1.934,.324-.115,.101-.285,.089-.38-.033-.094-.122-.076-.304,.04-.408,.041-.036,1.017-.893,2.439-.439,.142,.045,.22,.207,.174,.36-.022,.074-.069,.133-.128,.169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.447,316.928c-.054,.044-.123,.066-.195,.058-.148-.018-.251-.161-.231-.32,.201-1.592,1.321-2.208,1.37-2.233,.135-.072,.296-.015,.359,.128,.064,.142,.007,.316-.128,.389-.044,.023-.906,.514-1.066,1.78-.01,.082-.052,.152-.109,.198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,315.7l-1.139,.191s.864,.582,1.139-.191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.358,316.111s-4.488-1.912-5.908-8.064c0,0-6.892,.799-8.402,7.236,0,0-.433-8.872,9.303-10.686,9.736-1.814,8.627,9.347,8.062,10.576-.565,1.23-3.056,.938-3.056,.938Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.595,315.313c-.114,1.351-.797,2.486-1.603,3.143-1.212,.988-2.43-.095-2.606-1.691-.158-1.436,.282-3.681,1.745-4.038,1.442-.351,2.595,1.04,2.465,2.586Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.619,323.386c.727,.452,1.825,1.474,1.825,1.474,.111-.083,.221-.166,.327-.254,1.471-1.161,1.77-2.185,1.655-2.969-.064-.428-.259-.786-.451-1.051-.22-.309-.446-.479-.446-.479-.412,1.081-1.7,2.269-2.414,2.874-.296,.257-.495,.404-.495,.404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.114,322.983l.549,.421c1.383-1.097,2.209-2.054,2.311-2.816-.22-.309-.446-.479-.446-.479-.412,1.081-1.7,2.269-2.414,2.874Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.771,324.606c1.471-1.161,1.77-2.185,1.655-2.969-.486,.415-1.026,.969-1.378,1.613-.271,.491-.318,.956-.277,1.356Z",
    style: {
      fill: "#de5753"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.01,348.757l-2.55-4.919-3.702,4.905s2.54,4.252,4.676,2.851l1.577-2.837Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.895 343.667 142.016 347.857 144.757 348.743 148.46 343.838 143.895 343.667",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.296,345.88c.161-2.255,.376-4.601,.661-7.01-.787-.813-1.658-1.468-2.566-1.822,0,0-.422,5.859,1.905,8.832Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,330.969v13.17c-.53-.67-.92-1.15-.99-1.24l-.01-.01c-1-1.46-1.69-2.77-2.16-3.92-2.69-6.63,2.19-8.45,2.19-8.45,0,0,.35,.11,.97,.45Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,330.969v13.17c-.53-.67-.92-1.15-.99-1.24l-.01-.01c-1-1.46-1.69-2.77-2.16-3.92-2.69-6.63,2.19-8.45,2.19-8.45,0,0,.35,.11,.97,.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.825,344.543l-8.888,3.713s-.213,.907,.936,1.113l9.191-3.699s-.317-1.16-1.24-1.127Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.278,347.233s-2.382-.982-2.851-1.029c-.469-.046-2.638,.751-2.638,.751,0,0,.151,1.015,1.969,1.076,0,0,.755,2.12,2.244,2.027,1.489-.094,1.277-2.825,1.277-2.825Z",
    style: {
      fill: "#d9877c"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Maze--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "96.448 281.651 96.448 293.256 106.49 293.256 106.49 307.357 96.448 307.357 96.448 310.357 109.49 310.357 109.49 290.256 99.448 290.256 99.448 284.651 142.949 284.651 142.949 315.969 127.597 315.969 127.597 298.3 124.597 298.3 124.597 317.469 124.597 318.969 124.597 323.887 96.448 323.887 96.448 326.887 105.831 326.887 105.831 333.236 108.831 333.236 108.831 326.887 124.597 326.887 124.597 333.236 127.597 333.236 127.597 318.969 142.949 318.969 142.949 340.834 145.949 340.834 145.949 281.651 96.448 281.651"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "133.725 337.834 118.214 337.834 118.214 331.739 115.214 331.739 115.214 337.834 99.448 337.834 99.448 331.739 96.448 331.739 96.448 337.834 90.767 337.834 90.767 318.969 118.81 318.969 118.81 293.256 133.725 293.256 133.725 309.683 136.725 309.683 136.725 290.256 115.81 290.256 115.81 315.969 90.767 315.969 90.767 301.668 101.161 301.668 101.161 298.668 90.767 298.668 90.767 281.651 87.767 281.651 87.767 340.834 136.725 340.834 136.725 325.917 133.725 325.917 133.725 337.834"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.707,283.649h-.006c-.276-.003-.497-.23-.494-.506,.012-.924,.028-1.506,.028-1.506,.008-.276,.235-.476,.514-.486,.276,.008,.493,.238,.486,.514,0,.002-.016,.578-.028,1.491-.003,.274-.227,.494-.5,.494Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.936,340.917h-.008c-.276-.004-.497-.231-.492-.508,.015-.942,.026-1.966,.029-3.019,0-.276,.225-.499,.5-.499h.001c.276,0,.5,.226,.499,.501-.003,1.057-.015,2.085-.029,3.031-.004,.273-.228,.492-.5,.492Zm-32-4.399h-.026c-1.106-.058-2.271-.305-3.116-.662-.254-.107-.373-.4-.266-.655,.107-.255,.4-.374,.655-.266,.744,.314,1.782,.532,2.779,.583,.276,.015,.488,.249,.474,.525-.014,.267-.235,.474-.499,.474Zm20.163-.535c-.253,0-.471-.192-.497-.45-.028-.275,.172-.52,.447-.548,1.217-.123,1.978-.431,2.326-.942,.155-.228,.467-.286,.695-.131,.228,.156,.287,.467,.131,.695-.533,.781-1.502,1.217-3.052,1.374-.017,.002-.034,.003-.051,.003Zm-3.011-.041c-.028,0-.056-.003-.084-.007-1.22-.207-2.137-.707-2.887-1.572-.181-.209-.158-.524,.051-.705,.208-.181,.524-.159,.705,.051,.589,.68,1.319,1.074,2.298,1.24,.272,.046,.456,.305,.41,.577-.042,.244-.253,.417-.493,.417Zm-14.24-.006c-.148,0-.295-.066-.394-.192-.17-.217-.132-.532,.085-.702,.131-.102,.217-.215,.263-.344,.127-.355,.183-.852,.242-1.38,.029-.259,.059-.527,.099-.797,.041-.272,.288-.466,.568-.421,.273,.04,.462,.294,.421,.568-.038,.258-.067,.514-.095,.763-.066,.586-.128,1.141-.294,1.605-.111,.308-.309,.575-.588,.794-.091,.072-.2,.106-.308,.106Zm29.104-1.067c-.273,0-.496-.219-.5-.493-.015-1.044-.04-2.064-.081-3.01-.012-.276,.202-.509,.478-.521,.285-.014,.509,.202,.521,.478,.041,.954,.067,1.984,.082,3.039,.004,.276-.217,.503-.493,.507h-.007Zm-36.686-1.286c-.223,0-.426-.15-.484-.376-.055-.212-.105-.428-.154-.642-.177-.769-.36-1.563-.744-1.849-.222-.165-.267-.479-.102-.7,.165-.222,.478-.268,.7-.102,.678,.506,.893,1.439,1.121,2.426,.047,.205,.095,.413,.148,.617,.069,.267-.092,.54-.36,.609-.041,.011-.083,.016-.125,.016Zm17.633-1.609c-.167,0-.33-.084-.425-.235-.406-.652-.958-1.374-1.965-1.789-.255-.105-.377-.398-.272-.653,.105-.255,.397-.376,.653-.272,1.277,.525,1.971,1.443,2.433,2.184,.146,.234,.075,.543-.16,.689-.082,.051-.174,.076-.264,.076Zm10.125-.093c-.243,0-.456-.177-.494-.425l-.282-1.741c-.067-.404-.137-.825-.197-1.251-.039-.273,.151-.526,.425-.565,.274-.043,.526,.151,.566,.425,.059,.418,.128,.831,.194,1.228l.283,1.754c.042,.273-.146,.528-.419,.569-.025,.004-.051,.006-.076,.006Zm-33.811-1.306c-.36,0-.714-.007-1.054-.026-.276-.015-.487-.252-.471-.527,.015-.276,.252-.497,.527-.471,.84,.047,1.774,.017,2.651-.01l.331-.01c.263,.004,.506,.209,.515,.485,.008,.276-.209,.506-.485,.515l-.33,.01c-.551,.017-1.124,.035-1.684,.035Zm15.688-.145c-.146,0-.29-.063-.388-.185-.174-.214-.142-.529,.072-.703,.751-.611,1.775-.931,3.132-.978,.261-.028,.508,.206,.517,.482,.01,.276-.206,.507-.482,.517-1.131,.04-1.961,.287-2.537,.755-.093,.076-.204,.112-.315,.112Zm-19.44-.897c-.163,0-.323-.08-.419-.227-.363-.557-.547-1.298-.547-2.202,0-.339,.026-.703,.08-1.081,.039-.273,.293-.463,.565-.425,.273,.039,.463,.292,.425,.565-.047,.331-.071,.647-.07,.939,0,.698,.133,1.27,.385,1.656,.151,.231,.085,.542-.146,.692-.084,.055-.179,.081-.273,.081Zm46.202-.707c-.258,0-.477-.199-.498-.46l-.071-.941c-.058-.793-.108-1.479-.192-2.035-.041-.273,.147-.528,.42-.569,.279-.033,.528,.148,.569,.421,.089,.594,.14,1.296,.2,2.11l.071,.935c.022,.275-.184,.516-.459,.538h-.04Zm-9.228-2.945c-.022,0-.045-.001-.068-.004-.274-.037-.465-.289-.428-.563,.182-1.343,.775-2.302,1.764-2.851,.241-.136,.546-.047,.68,.194,.134,.241,.047,.546-.194,.68-.707,.393-1.119,1.084-1.258,2.112-.034,.251-.249,.433-.495,.433Zm-36.469-2.163c-.075,0-.152-.017-.224-.053-.247-.123-.347-.424-.223-.671,.162-.324,.336-.616,.514-.869,.304-.428,.993-.719,2.235-.942,.271-.052,.532,.132,.581,.404s-.132,.532-.404,.581c-1.354,.243-1.575,.506-1.596,.536-.15,.212-.297,.461-.437,.739-.087,.175-.264,.276-.447,.276Zm43.889-.304c-.066,0-.131-.013-.195-.039-.581-.246-1.443-.384-2.793-.446-.276-.013-.489-.247-.477-.522,.013-.276,.254-.498,.523-.477,1.475,.068,2.442,.23,3.137,.524,.254,.108,.373,.401,.266,.655-.081,.191-.266,.305-.46,.305Zm-23.366-1.506h-.021c-.721-.031-1.771-.072-3.018-.11-.276-.009-.493-.239-.485-.515,.009-.276,.271-.478,.515-.485,1.252,.039,2.306,.08,3.03,.11,.276,.012,.49,.245,.478,.52-.011,.269-.232,.479-.499,.479Zm3.019-.006c-.246,0-.459-.181-.495-.43-.039-.274,.152-.526,.425-.565,1-.141,1.634-.531,2.119-1.306,.146-.234,.456-.305,.689-.159,.234,.146,.305,.455,.159,.689-.641,1.023-1.539,1.584-2.827,1.766-.024,.003-.047,.005-.07,.005Zm-18.144-.055c-.261,0-.481-.203-.499-.468-.018-.275,.191-.513,.467-.531,.947-.061,1.978-.102,3.044-.126h.011c.271,0,.494,.216,.5,.489,.006,.276-.212,.505-.489,.511-1.052,.023-2.068,.063-3.002,.124h-.033Zm9.075-.123h-.009c-.975-.017-1.993-.029-3.018-.031-.276,0-.5-.225-.499-.501s.224-.499,.5-.499h0c1.03,.001,2.055,.013,3.034,.031,.276,.005,.496,.233,.491,.509-.005,.274-.228,.491-.5,.491Zm12.477-4.207c-.026,0-.054-.002-.081-.006-.272-.044-.458-.301-.413-.574,.135-.825,.222-1.816,.259-2.945,.009-.276,.257-.493,.516-.483,.276,.009,.492,.24,.483,.516-.039,1.188-.127,2.193-.27,3.073-.04,.245-.253,.419-.493,.419Zm-15.806-1.886h-.002c-1.024-.005-2.061-.078-3.082-.216-.274-.037-.465-.289-.428-.563,.037-.273,.29-.464,.563-.428,.978,.133,1.971,.202,2.952,.207,.276,.001,.499,.226,.498,.502-.001,.275-.225,.498-.5,.498Zm3.015-.204c-.243,0-.457-.178-.494-.425-.041-.273,.147-.528,.42-.569,1.098-.165,2.029-.424,2.767-.77,.25-.118,.548-.01,.664,.241,.117,.25,.009,.547-.241,.665-.825,.387-1.848,.674-3.041,.853-.025,.003-.051,.005-.075,.005Zm-8.991-.627c-.046,0-.094-.006-.141-.02-1.125-.331-2.1-.742-2.897-1.222-.236-.143-.313-.45-.171-.687,.143-.236,.45-.313,.686-.171,.725,.436,1.621,.813,2.664,1.12,.265,.078,.417,.356,.338,.621-.064,.218-.263,.359-.479,.359Zm37.806-.986c-.265,0-.485-.208-.499-.475-.014-.276,.199-.511,.475-.524,.565-.028,1.142-.093,1.669-.188h0s.168-.077,.393-.647c.102-.257,.392-.383,.649-.282,.257,.101,.383,.392,.282,.648-.301,.766-.676,1.18-1.146,1.265-.57,.103-1.191,.173-1.798,.203h-.025Zm-3.004-.245c-.041,0-.082-.005-.122-.015-1.279-.321-2.224-.911-2.806-1.753-.157-.227-.101-.539,.127-.696,.226-.157,.538-.101,.695,.127,.441,.637,1.19,1.092,2.227,1.353,.268,.067,.431,.339,.363,.606-.057,.227-.261,.379-.484,.379Zm-20.933-1.082c-.029,0-.058-.002-.087-.008-.272-.048-.454-.307-.405-.579,.095-.539,.141-1.309,.14-2.353l-.004-.57c-.004-.276,.216-.503,.493-.507,.246-.004,.503,.216,.507,.493l.004,.584c0,1.103-.05,1.93-.156,2.528-.043,.242-.253,.413-.492,.413Zm8.186-1.002c-.274,0-.497-.22-.5-.494-.013-1.048-.025-2.06-.03-3.028-.002-.276,.221-.501,.497-.502h.003c.275,0,.498,.222,.5,.497,.005,.966,.017,1.975,.03,3.021,.003,.276-.218,.502-.494,.506h-.006Zm-26.876-.013c-.19,0-.373-.109-.456-.294-.37-.818-.558-1.598-.558-2.317,0-.326,.038-.645,.116-.949,.067-.269,.343-.432,.607-.361,.268,.068,.43,.34,.361,.607-.056,.223-.085,.459-.084,.702,0,.577,.158,1.218,.469,1.906,.114,.252,.002,.548-.249,.662-.067,.03-.137,.044-.206,.044Zm45.788-1.757c-.023,0-.045-.001-.068-.004-.273-.037-.465-.289-.428-.563,.118-.867,.213-1.868,.284-2.977,.018-.275,.252-.483,.531-.467,.275,.018,.485,.255,.467,.531-.072,1.132-.17,2.157-.291,3.048-.034,.251-.248,.433-.495,.433Zm-9.285-.608c-.273,0-.496-.219-.5-.493l-.009-.776c-.007-.693-.015-1.453-.041-2.245-.008-.276,.208-.507,.484-.515,.263-.014,.507,.208,.515,.484,.025,.799,.033,1.566,.041,2.266l.009,.772c.004,.276-.217,.503-.493,.507h-.007Zm-17.771-2.661c-.266,0-.487-.21-.499-.478l-.142-3.021c-.013-.276,.201-.51,.477-.523,.28-.018,.51,.201,.522,.477l.142,3.022c.012,.276-.201,.51-.477,.522h-.023Zm-17.273-.176c-.173,0-.341-.089-.433-.25-.139-.239-.057-.545,.182-.683,.823-.476,1.838-.82,3.017-1.023,.276-.043,.531,.137,.578,.408,.047,.272-.136,.531-.408,.578-1.062,.183-1.966,.487-2.686,.903-.079,.046-.165,.067-.25,.067Zm25.406-.833h-.011c-.276-.006-.495-.235-.489-.511,.026-1.179,.077-2.178,.156-3.055,.025-.275,.272-.477,.543-.453,.275,.025,.478,.268,.453,.543-.077,.854-.127,1.831-.152,2.987-.006,.272-.229,.489-.5,.489Zm-19.542-.334c-.261,0-.48-.202-.498-.466-.019-.275,.19-.514,.465-.533,1.036-.07,1.764-.446,2.164-1.118,.141-.237,.447-.315,.686-.174,.237,.141,.315,.448,.174,.686-.397,.667-1.232,1.488-2.956,1.604h-.034Zm38.873-1.422h-.01c-.276-.005-.496-.233-.49-.51,.01-.529,.016-1.064,.016-1.602,0-.468-.003-.938-.011-1.406-.004-.276,.216-.503,.492-.508,.321-.013,.504,.216,.508,.492,.008,.475,.012,.95,.011,1.423,0,.544-.005,1.085-.016,1.621-.005,.272-.228,.49-.5,.49Zm-9.944-.625c-.251,0-.468-.189-.496-.444-.126-1.118-.304-2.062-.545-2.887-.077-.265,.075-.543,.34-.62,.265-.079,.543,.075,.62,.34,.257,.88,.446,1.88,.579,3.055,.031,.274-.167,.522-.441,.553-.019,.002-.038,.003-.057,.003Zm-26.09-2.251c-.227,0-.432-.155-.486-.385-.209-.89-.658-1.794-1.229-2.483-.176-.212-.147-.528,.065-.704,.213-.178,.527-.147,.704,.065,.677,.815,1.186,1.842,1.433,2.892,.063,.269-.104,.538-.372,.601-.039,.009-.077,.013-.115,.013Zm8.314-.403c-.27,0-.492-.215-.499-.486-.022-.786-.035-1.569-.035-2.336l.004-.709c.003-.274,.226-.495,.5-.495h.005c.276,.003,.498,.229,.495,.505l-.004,.698c0,.758,.013,1.531,.035,2.308,.007,.276-.211,.506-.486,.514h-.014Zm9.037-.965c-.044,0-.088-.006-.133-.018-.266-.073-.423-.349-.35-.615,.355-1.295,.871-2.23,1.575-2.857,.206-.185,.521-.165,.706,.041,.184,.206,.165,.523-.041,.706-.556,.495-.974,1.272-1.276,2.375-.06,.222-.262,.368-.481,.368Zm18.583-1.806c-.264,0-.484-.207-.499-.473-.056-1.056-.133-2.062-.229-2.994-.028-.274,.172-.52,.447-.548,.269-.027,.52,.171,.548,.447,.097,.947,.175,1.97,.232,3.041,.015,.276-.197,.511-.473,.526h-.027Zm-11.739-.235c-.142,0-.283-.06-.382-.177-.601-.709-1.333-1.096-2.236-1.183l.069-.998c1.186,.115,2.162,.63,2.929,1.535,.179,.21,.153,.526-.058,.705-.094,.08-.208,.119-.323,.119Zm-28.193-.535c-.024,0-.05-.002-.075-.005-.617-.093-1.285-.13-1.932-.166-.358-.02-.712-.04-1.054-.068-.275-.022-.479-.264-.456-.54,.023-.275,.262-.482,.539-.457,.333,.027,.677,.046,1.026,.066,.669,.038,1.362,.076,2.025,.176,.273,.041,.461,.296,.42,.569-.038,.248-.251,.425-.494,.425Zm-5.784-1.235c-.149,0-.296-.066-.395-.192-.131-.169-.239-.359-.319-.564-.211-.542-.376-1.391-.501-2.596-.029-.274,.17-.52,.445-.549,.28-.03,.52,.171,.549,.445,.115,1.099,.263,1.884,.439,2.335,.045,.117,.103,.22,.177,.314,.169,.218,.131,.532-.087,.702-.091,.071-.2,.105-.307,.105Zm18.204-1.272c-.015,0-.029,0-.044-.002-.275-.024-.479-.267-.454-.542,.108-1.222,.274-2.227,.509-3.071,.075-.266,.35-.419,.616-.348,.266,.074,.421,.35,.348,.616-.215,.773-.376,1.746-.477,2.89-.023,.26-.241,.456-.498,.456Zm26.858-2.737c-.235,0-.444-.166-.49-.405-.348-1.799-.699-2.386-.877-2.576-.189-.202-.179-.518,.023-.707,.202-.188,.518-.177,.707,.022,.454,.484,.823,1.488,1.129,3.071,.053,.271-.124,.533-.396,.585-.032,.006-.064,.009-.095,.009Zm-45.983-1.916c-.267,0-.488-.211-.499-.48-.041-1.021-.061-2.066-.069-3.041-.002-.276,.22-.502,.496-.504h.004c.274,0,.498,.221,.5,.496,.008,.965,.029,1.999,.068,3.01,.011,.276-.204,.508-.48,.519h-.02Zm21.161-.844c-.171,0-.338-.088-.432-.247-.14-.238-.061-.544,.178-.685,.115-.067,.234-.126,.358-.173,.65-.252,1.565-.481,2.719-.681,.273-.046,.531,.135,.578,.407,.047,.272-.135,.531-.407,.578-1.089,.189-1.94,.4-2.529,.628-.074,.028-.144,.063-.212,.103-.08,.047-.167,.069-.253,.069Zm21.002-1.055c-.028,0-.056-.003-.084-.007-.833-.142-1.828-.254-2.958-.336-.275-.019-.483-.259-.463-.534,.019-.276,.264-.484,.534-.463,1.162,.083,2.189,.2,3.053,.347,.272,.046,.456,.305,.41,.577-.041,.244-.253,.416-.493,.416Zm-15.096-.135c-.254,0-.471-.192-.497-.45-.027-.275,.173-.52,.448-.547,.959-.096,1.981-.174,3.039-.233,.265-.013,.512,.195,.527,.471,.016,.276-.195,.512-.471,.527-1.036,.058-2.044,.135-2.995,.23-.017,.001-.034,.002-.05,.002Zm9.067-.341h-.01c-.521-.011-1.052-.018-1.584-.015-.472,0-.946,.005-1.421,.014h-.009c-.272,0-.495-.218-.5-.491-.005-.276,.215-.504,.491-.509,.504-.009,1.004-.017,1.507-.014,.518,0,1.031,.005,1.538,.015,.276,.006,.495,.234,.49,.51-.006,.272-.229,.49-.5,.49Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.823,345.719h-.018c-.276-.01-.492-.241-.482-.517,0-.002,.02-.564,.044-1.494,.007-.276,.26-.475,.513-.487,.276,.007,.494,.237,.487,.513-.025,.936-.045,1.502-.045,1.502-.009,.271-.231,.483-.499,.483Z",
    style: {
      fill: "#071530"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.707,283.649h-.006c-.276-.003-.497-.23-.494-.506,.012-.924,.028-1.506,.028-1.506,.008-.276,.235-.476,.514-.486,.276,.008,.493,.238,.486,.514,0,.002-.016,.578-.028,1.491-.003,.274-.227,.494-.5,.494Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.936,340.917h-.008c-.276-.004-.497-.231-.492-.508,.015-.942,.026-1.966,.029-3.019,0-.276,.225-.499,.5-.499h.001c.276,0,.5,.226,.499,.501-.003,1.057-.015,2.085-.029,3.031-.004,.273-.228,.492-.5,.492Zm-32-4.399h-.026c-1.106-.058-2.271-.305-3.116-.662-.254-.107-.373-.4-.266-.655,.107-.255,.4-.374,.655-.266,.744,.314,1.782,.532,2.779,.583,.276,.015,.488,.249,.474,.525-.014,.267-.235,.474-.499,.474Zm20.163-.535c-.253,0-.471-.192-.497-.45-.028-.275,.172-.52,.447-.548,1.217-.123,1.978-.431,2.326-.942,.155-.228,.467-.286,.695-.131,.228,.156,.287,.467,.131,.695-.533,.781-1.502,1.217-3.052,1.374-.017,.002-.034,.003-.051,.003Zm-3.011-.041c-.028,0-.056-.003-.084-.007-1.22-.207-2.137-.707-2.887-1.572-.181-.209-.158-.524,.051-.705,.208-.181,.524-.159,.705,.051,.589,.68,1.319,1.074,2.298,1.24,.272,.046,.456,.305,.41,.577-.042,.244-.253,.417-.493,.417Zm-14.24-.006c-.148,0-.295-.066-.394-.192-.17-.217-.132-.532,.085-.702,.131-.102,.217-.215,.263-.344,.127-.355,.183-.852,.242-1.38,.029-.259,.059-.527,.099-.797,.041-.272,.288-.466,.568-.421,.273,.04,.462,.294,.421,.568-.038,.258-.067,.514-.095,.763-.066,.586-.128,1.141-.294,1.605-.111,.308-.309,.575-.588,.794-.091,.072-.2,.106-.308,.106Zm29.104-1.067c-.273,0-.496-.219-.5-.493-.015-1.044-.04-2.064-.081-3.01-.012-.276,.202-.509,.478-.521,.285-.014,.509,.202,.521,.478,.041,.954,.067,1.984,.082,3.039,.004,.276-.217,.503-.493,.507h-.007Zm-36.686-1.286c-.223,0-.426-.15-.484-.376-.055-.212-.105-.428-.154-.642-.177-.769-.36-1.563-.744-1.849-.222-.165-.267-.479-.102-.7,.165-.222,.478-.268,.7-.102,.678,.506,.893,1.439,1.121,2.426,.047,.205,.095,.413,.148,.617,.069,.267-.092,.54-.36,.609-.041,.011-.083,.016-.125,.016Zm17.633-1.609c-.167,0-.33-.084-.425-.235-.406-.652-.958-1.374-1.965-1.789-.255-.105-.377-.398-.272-.653,.105-.255,.397-.376,.653-.272,1.277,.525,1.971,1.443,2.433,2.184,.146,.234,.075,.543-.16,.689-.082,.051-.174,.076-.264,.076Zm10.125-.093c-.243,0-.456-.177-.494-.425l-.282-1.741c-.067-.404-.137-.825-.197-1.251-.039-.273,.151-.526,.425-.565,.274-.043,.526,.151,.566,.425,.059,.418,.128,.831,.194,1.228l.283,1.754c.042,.273-.146,.528-.419,.569-.025,.004-.051,.006-.076,.006Zm-33.811-1.306c-.36,0-.714-.007-1.054-.026-.276-.015-.487-.252-.471-.527,.015-.276,.252-.497,.527-.471,.84,.047,1.774,.017,2.651-.01l.331-.01c.263,.004,.506,.209,.515,.485,.008,.276-.209,.506-.485,.515l-.33,.01c-.551,.017-1.124,.035-1.684,.035Zm15.688-.145c-.146,0-.29-.063-.388-.185-.174-.214-.142-.529,.072-.703,.751-.611,1.775-.931,3.132-.978,.261-.028,.508,.206,.517,.482,.01,.276-.206,.507-.482,.517-1.131,.04-1.961,.287-2.537,.755-.093,.076-.204,.112-.315,.112Zm-19.44-.897c-.163,0-.323-.08-.419-.227-.363-.557-.547-1.298-.547-2.202,0-.339,.026-.703,.08-1.081,.039-.273,.293-.463,.565-.425,.273,.039,.463,.292,.425,.565-.047,.331-.071,.647-.07,.939,0,.698,.133,1.27,.385,1.656,.151,.231,.085,.542-.146,.692-.084,.055-.179,.081-.273,.081Zm46.202-.707c-.258,0-.477-.199-.498-.46l-.071-.941c-.058-.793-.108-1.479-.192-2.035-.041-.273,.147-.528,.42-.569,.279-.033,.528,.148,.569,.421,.089,.594,.14,1.296,.2,2.11l.071,.935c.022,.275-.184,.516-.459,.538h-.04Zm-9.228-2.945c-.022,0-.045-.001-.068-.004-.274-.037-.465-.289-.428-.563,.182-1.343,.775-2.302,1.764-2.851,.241-.136,.546-.047,.68,.194,.134,.241,.047,.546-.194,.68-.707,.393-1.119,1.084-1.258,2.112-.034,.251-.249,.433-.495,.433Zm-36.469-2.163c-.075,0-.152-.017-.224-.053-.247-.123-.347-.424-.223-.671,.162-.324,.336-.616,.514-.869,.304-.428,.993-.719,2.235-.942,.271-.052,.532,.132,.581,.404s-.132,.532-.404,.581c-1.354,.243-1.575,.506-1.596,.536-.15,.212-.297,.461-.437,.739-.087,.175-.264,.276-.447,.276Zm43.889-.304c-.066,0-.131-.013-.195-.039-.581-.246-1.443-.384-2.793-.446-.276-.013-.489-.247-.477-.522,.013-.276,.254-.498,.523-.477,1.475,.068,2.442,.23,3.137,.524,.254,.108,.373,.401,.266,.655-.081,.191-.266,.305-.46,.305Zm-23.366-1.506h-.021c-.721-.031-1.771-.072-3.018-.11-.276-.009-.493-.239-.485-.515,.009-.276,.271-.478,.515-.485,1.252,.039,2.306,.08,3.03,.11,.276,.012,.49,.245,.478,.52-.011,.269-.232,.479-.499,.479Zm3.019-.006c-.246,0-.459-.181-.495-.43-.039-.274,.152-.526,.425-.565,1-.141,1.634-.531,2.119-1.306,.146-.234,.456-.305,.689-.159,.234,.146,.305,.455,.159,.689-.641,1.023-1.539,1.584-2.827,1.766-.024,.003-.047,.005-.07,.005Zm-18.144-.055c-.261,0-.481-.203-.499-.468-.018-.275,.191-.513,.467-.531,.947-.061,1.978-.102,3.044-.126h.011c.271,0,.494,.216,.5,.489,.006,.276-.212,.505-.489,.511-1.052,.023-2.068,.063-3.002,.124h-.033Zm9.075-.123h-.009c-.975-.017-1.993-.029-3.018-.031-.276,0-.5-.225-.499-.501s.224-.499,.5-.499h0c1.03,.001,2.055,.013,3.034,.031,.276,.005,.496,.233,.491,.509-.005,.274-.228,.491-.5,.491Zm12.477-4.207c-.026,0-.054-.002-.081-.006-.272-.044-.458-.301-.413-.574,.135-.825,.222-1.816,.259-2.945,.009-.276,.257-.493,.516-.483,.276,.009,.492,.24,.483,.516-.039,1.188-.127,2.193-.27,3.073-.04,.245-.253,.419-.493,.419Zm-15.806-1.886h-.002c-1.024-.005-2.061-.078-3.082-.216-.274-.037-.465-.289-.428-.563,.037-.273,.29-.464,.563-.428,.978,.133,1.971,.202,2.952,.207,.276,.001,.499,.226,.498,.502-.001,.275-.225,.498-.5,.498Zm3.015-.204c-.243,0-.457-.178-.494-.425-.041-.273,.147-.528,.42-.569,1.098-.165,2.029-.424,2.767-.77,.25-.118,.548-.01,.664,.241,.117,.25,.009,.547-.241,.665-.825,.387-1.848,.674-3.041,.853-.025,.003-.051,.005-.075,.005Zm-8.991-.627c-.046,0-.094-.006-.141-.02-1.125-.331-2.1-.742-2.897-1.222-.236-.143-.313-.45-.171-.687,.143-.236,.45-.313,.686-.171,.725,.436,1.621,.813,2.664,1.12,.265,.078,.417,.356,.338,.621-.064,.218-.263,.359-.479,.359Zm37.806-.986c-.265,0-.485-.208-.499-.475-.014-.276,.199-.511,.475-.524,.565-.028,1.142-.093,1.669-.188h0s.168-.077,.393-.647c.102-.257,.392-.383,.649-.282,.257,.101,.383,.392,.282,.648-.301,.766-.676,1.18-1.146,1.265-.57,.103-1.191,.173-1.798,.203h-.025Zm-3.004-.245c-.041,0-.082-.005-.122-.015-1.279-.321-2.224-.911-2.806-1.753-.157-.227-.101-.539,.127-.696,.226-.157,.538-.101,.695,.127,.441,.637,1.19,1.092,2.227,1.353,.268,.067,.431,.339,.363,.606-.057,.227-.261,.379-.484,.379Zm-20.933-1.082c-.029,0-.058-.002-.087-.008-.272-.048-.454-.307-.405-.579,.095-.539,.141-1.309,.14-2.353l-.004-.57c-.004-.276,.216-.503,.493-.507,.246-.004,.503,.216,.507,.493l.004,.584c0,1.103-.05,1.93-.156,2.528-.043,.242-.253,.413-.492,.413Zm8.186-1.002c-.274,0-.497-.22-.5-.494-.013-1.048-.025-2.06-.03-3.028-.002-.276,.221-.501,.497-.502h.003c.275,0,.498,.222,.5,.497,.005,.966,.017,1.975,.03,3.021,.003,.276-.218,.502-.494,.506h-.006Zm-26.876-.013c-.19,0-.373-.109-.456-.294-.37-.818-.558-1.598-.558-2.317,0-.326,.038-.645,.116-.949,.067-.269,.343-.432,.607-.361,.268,.068,.43,.34,.361,.607-.056,.223-.085,.459-.084,.702,0,.577,.158,1.218,.469,1.906,.114,.252,.002,.548-.249,.662-.067,.03-.137,.044-.206,.044Zm45.788-1.757c-.023,0-.045-.001-.068-.004-.273-.037-.465-.289-.428-.563,.118-.867,.213-1.868,.284-2.977,.018-.275,.252-.483,.531-.467,.275,.018,.485,.255,.467,.531-.072,1.132-.17,2.157-.291,3.048-.034,.251-.248,.433-.495,.433Zm-9.285-.608c-.273,0-.496-.219-.5-.493l-.009-.776c-.007-.693-.015-1.453-.041-2.245-.008-.276,.208-.507,.484-.515,.263-.014,.507,.208,.515,.484,.025,.799,.033,1.566,.041,2.266l.009,.772c.004,.276-.217,.503-.493,.507h-.007Zm-17.771-2.661c-.266,0-.487-.21-.499-.478l-.142-3.021c-.013-.276,.201-.51,.477-.523,.28-.018,.51,.201,.522,.477l.142,3.022c.012,.276-.201,.51-.477,.522h-.023Zm-17.273-.176c-.173,0-.341-.089-.433-.25-.139-.239-.057-.545,.182-.683,.823-.476,1.838-.82,3.017-1.023,.276-.043,.531,.137,.578,.408,.047,.272-.136,.531-.408,.578-1.062,.183-1.966,.487-2.686,.903-.079,.046-.165,.067-.25,.067Zm25.406-.833h-.011c-.276-.006-.495-.235-.489-.511,.026-1.179,.077-2.178,.156-3.055,.025-.275,.272-.477,.543-.453,.275,.025,.478,.268,.453,.543-.077,.854-.127,1.831-.152,2.987-.006,.272-.229,.489-.5,.489Zm-19.542-.334c-.261,0-.48-.202-.498-.466-.019-.275,.19-.514,.465-.533,1.036-.07,1.764-.446,2.164-1.118,.141-.237,.447-.315,.686-.174,.237,.141,.315,.448,.174,.686-.397,.667-1.232,1.488-2.956,1.604h-.034Zm38.873-1.422h-.01c-.276-.005-.496-.233-.49-.51,.01-.529,.016-1.064,.016-1.602,0-.468-.003-.938-.011-1.406-.004-.276,.216-.503,.492-.508,.321-.013,.504,.216,.508,.492,.008,.475,.012,.95,.011,1.423,0,.544-.005,1.085-.016,1.621-.005,.272-.228,.49-.5,.49Zm-9.944-.625c-.251,0-.468-.189-.496-.444-.126-1.118-.304-2.062-.545-2.887-.077-.265,.075-.543,.34-.62,.265-.079,.543,.075,.62,.34,.257,.88,.446,1.88,.579,3.055,.031,.274-.167,.522-.441,.553-.019,.002-.038,.003-.057,.003Zm-26.09-2.251c-.227,0-.432-.155-.486-.385-.209-.89-.658-1.794-1.229-2.483-.176-.212-.147-.528,.065-.704,.213-.178,.527-.147,.704,.065,.677,.815,1.186,1.842,1.433,2.892,.063,.269-.104,.538-.372,.601-.039,.009-.077,.013-.115,.013Zm8.314-.403c-.27,0-.492-.215-.499-.486-.022-.786-.035-1.569-.035-2.336l.004-.709c.003-.274,.226-.495,.5-.495h.005c.276,.003,.498,.229,.495,.505l-.004,.698c0,.758,.013,1.531,.035,2.308,.007,.276-.211,.506-.486,.514h-.014Zm9.037-.965c-.044,0-.088-.006-.133-.018-.266-.073-.423-.349-.35-.615,.355-1.295,.871-2.23,1.575-2.857,.206-.185,.521-.165,.706,.041,.184,.206,.165,.523-.041,.706-.556,.495-.974,1.272-1.276,2.375-.06,.222-.262,.368-.481,.368Zm18.583-1.806c-.264,0-.484-.207-.499-.473-.056-1.056-.133-2.062-.229-2.994-.028-.274,.172-.52,.447-.548,.269-.027,.52,.171,.548,.447,.097,.947,.175,1.97,.232,3.041,.015,.276-.197,.511-.473,.526h-.027Zm-11.739-.235c-.142,0-.283-.06-.382-.177-.601-.709-1.333-1.096-2.236-1.183l.069-.998c1.186,.115,2.162,.63,2.929,1.535,.179,.21,.153,.526-.058,.705-.094,.08-.208,.119-.323,.119Zm-28.193-.535c-.024,0-.05-.002-.075-.005-.617-.093-1.285-.13-1.932-.166-.358-.02-.712-.04-1.054-.068-.275-.022-.479-.264-.456-.54,.023-.275,.262-.482,.539-.457,.333,.027,.677,.046,1.026,.066,.669,.038,1.362,.076,2.025,.176,.273,.041,.461,.296,.42,.569-.038,.248-.251,.425-.494,.425Zm-5.784-1.235c-.149,0-.296-.066-.395-.192-.131-.169-.239-.359-.319-.564-.211-.542-.376-1.391-.501-2.596-.029-.274,.17-.52,.445-.549,.28-.03,.52,.171,.549,.445,.115,1.099,.263,1.884,.439,2.335,.045,.117,.103,.22,.177,.314,.169,.218,.131,.532-.087,.702-.091,.071-.2,.105-.307,.105Zm18.204-1.272c-.015,0-.029,0-.044-.002-.275-.024-.479-.267-.454-.542,.108-1.222,.274-2.227,.509-3.071,.075-.266,.35-.419,.616-.348,.266,.074,.421,.35,.348,.616-.215,.773-.376,1.746-.477,2.89-.023,.26-.241,.456-.498,.456Zm26.858-2.737c-.235,0-.444-.166-.49-.405-.348-1.799-.699-2.386-.877-2.576-.189-.202-.179-.518,.023-.707,.202-.188,.518-.177,.707,.022,.454,.484,.823,1.488,1.129,3.071,.053,.271-.124,.533-.396,.585-.032,.006-.064,.009-.095,.009Zm-45.983-1.916c-.267,0-.488-.211-.499-.48-.041-1.021-.061-2.066-.069-3.041-.002-.276,.22-.502,.496-.504h.004c.274,0,.498,.221,.5,.496,.008,.965,.029,1.999,.068,3.01,.011,.276-.204,.508-.48,.519h-.02Zm21.161-.844c-.171,0-.338-.088-.432-.247-.14-.238-.061-.544,.178-.685,.115-.067,.234-.126,.358-.173,.65-.252,1.565-.481,2.719-.681,.273-.046,.531,.135,.578,.407,.047,.272-.135,.531-.407,.578-1.089,.189-1.94,.4-2.529,.628-.074,.028-.144,.063-.212,.103-.08,.047-.167,.069-.253,.069Zm21.002-1.055c-.028,0-.056-.003-.084-.007-.833-.142-1.828-.254-2.958-.336-.275-.019-.483-.259-.463-.534,.019-.276,.264-.484,.534-.463,1.162,.083,2.189,.2,3.053,.347,.272,.046,.456,.305,.41,.577-.041,.244-.253,.416-.493,.416Zm-15.096-.135c-.254,0-.471-.192-.497-.45-.027-.275,.173-.52,.448-.547,.959-.096,1.981-.174,3.039-.233,.265-.013,.512,.195,.527,.471,.016,.276-.195,.512-.471,.527-1.036,.058-2.044,.135-2.995,.23-.017,.001-.034,.002-.05,.002Zm9.067-.341h-.01c-.521-.011-1.052-.018-1.584-.015-.472,0-.946,.005-1.421,.014h-.009c-.272,0-.495-.218-.5-.491-.005-.276,.215-.504,.491-.509,.504-.009,1.004-.017,1.507-.014,.518,0,1.031,.005,1.538,.015,.276,.006,.495,.234,.49,.51-.006,.272-.229,.49-.5,.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.823,345.719h-.018c-.276-.01-.492-.241-.482-.517,0-.002,.02-.564,.044-1.494,.007-.276,.26-.475,.513-.487,.276,.007,.494,.237,.487,.513-.025,.936-.045,1.502-.045,1.502-.009,.271-.231,.483-.499,.483Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.584,279.566l.268-.594c.288,.21,.716,.355,1.124,.355,.467,0,.657-.156,.657-.365,0-.638-1.981-.2-1.981-1.465,0-.579,.467-1.061,1.435-1.061,.429,0,.867,.102,1.183,.302l-.244,.599c-.316-.18-.642-.268-.944-.268-.468,0-.647,.175-.647,.39,0,.628,1.981,.194,1.981,1.445,0,.57-.472,1.057-1.446,1.057-.54,0-1.085-.161-1.387-.394Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.611,277.137h-1.09v-.643h2.969v.643h-1.09v2.765h-.789v-2.765Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.982,279.171h-1.582l-.302,.73h-.808l1.519-3.407h.779l1.523,3.407h-.828l-.302-.73Zm-.248-.599l-.541-1.305-.54,1.305h1.081Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.632,279.901l-.657-.949h-.725v.949h-.789v-3.407h1.475c.91,0,1.479,.472,1.479,1.236,0,.511-.258,.886-.701,1.076l.764,1.095h-.847Zm-.74-2.765h-.643v1.188h.643c.482,0,.726-.224,.726-.594,0-.375-.244-.594-.726-.594Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.692,277.137h-1.09v-.643h2.969v.643h-1.09v2.765h-.789v-2.765Z",
    style: {
      fill: "#071530"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.619,344.025v.9h1.577v.633h-1.577v1.241h-.789v-3.407h2.575v.633h-1.787Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.936,343.393h.788v3.407h-.788v-3.407Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.656,343.393v3.407h-.647l-1.699-2.069v2.069h-.779v-3.407h.652l1.694,2.069v-2.069h.779Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.458,343.393h.789v3.407h-.789v-3.407Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.785,346.464l.268-.594c.288,.209,.716,.355,1.124,.355,.467,0,.657-.156,.657-.365,0-.638-1.981-.2-1.981-1.465,0-.579,.467-1.061,1.435-1.061,.429,0,.867,.103,1.183,.302l-.244,.599c-.316-.18-.642-.268-.944-.268-.467,0-.647,.175-.647,.39,0,.628,1.981,.194,1.981,1.445,0,.57-.472,1.057-1.446,1.057-.54,0-1.085-.161-1.387-.395Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.279,343.393v3.407h-.789v-1.397h-1.548v1.397h-.788v-3.407h.788v1.343h1.548v-1.343h.789Z",
    style: {
      fill: "#071530"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.584,279.566l.268-.594c.288,.21,.716,.355,1.124,.355,.467,0,.657-.156,.657-.365,0-.638-1.981-.2-1.981-1.465,0-.579,.467-1.061,1.435-1.061,.429,0,.867,.102,1.183,.302l-.244,.599c-.316-.18-.642-.268-.944-.268-.468,0-.647,.175-.647,.39,0,.628,1.981,.194,1.981,1.445,0,.57-.472,1.057-1.446,1.057-.54,0-1.085-.161-1.387-.394Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.611,277.137h-1.09v-.643h2.969v.643h-1.09v2.765h-.789v-2.765Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.982,279.171h-1.582l-.302,.73h-.808l1.519-3.407h.779l1.523,3.407h-.828l-.302-.73Zm-.248-.599l-.541-1.305-.54,1.305h1.081Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.632,279.901l-.657-.949h-.725v.949h-.789v-3.407h1.475c.91,0,1.479,.472,1.479,1.236,0,.511-.258,.886-.701,1.076l.764,1.095h-.847Zm-.74-2.765h-.643v1.188h.643c.482,0,.726-.224,.726-.594,0-.375-.244-.594-.726-.594Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.692,277.137h-1.09v-.643h2.969v.643h-1.09v2.765h-.789v-2.765Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.619,344.025v.9h1.577v.633h-1.577v1.241h-.789v-3.407h2.575v.633h-1.787Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.936,343.393h.788v3.407h-.788v-3.407Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.656,343.393v3.407h-.647l-1.699-2.069v2.069h-.779v-3.407h.652l1.694,2.069v-2.069h.779Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.458,343.393h.789v3.407h-.789v-3.407Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.785,346.464l.268-.594c.288,.209,.716,.355,1.124,.355,.467,0,.657-.156,.657-.365,0-.638-1.981-.2-1.981-1.465,0-.579,.467-1.061,1.435-1.061,.429,0,.867,.103,1.183,.302l-.244,.599c-.316-.18-.642-.268-.944-.268-.467,0-.647,.175-.647,.39,0,.628,1.981,.194,1.981,1.445,0,.57-.472,1.057-1.446,1.057-.54,0-1.085-.161-1.387-.395Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.279,343.393v3.407h-.789v-1.397h-1.548v1.397h-.788v-3.407h.788v1.343h1.548v-1.343h.789Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Creativity--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.678,204.624c0-2.482,1.895-4.293,4.45-4.293,1.295,0,2.422,.444,3.19,1.307l-.779,.755c-.648-.684-1.44-.995-2.363-.995-1.895,0-3.298,1.367-3.298,3.226s1.403,3.226,3.298,3.226c.923,0,1.715-.324,2.363-1.007l.779,.756c-.768,.863-1.895,1.319-3.202,1.319-2.542,0-4.438-1.811-4.438-4.293Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65,208.822l-1.811-2.579c-.168,.012-.348,.024-.527,.024h-2.075v2.555h-1.199v-8.395h3.274c2.183,0,3.502,1.104,3.502,2.927,0,1.295-.672,2.23-1.847,2.65l1.991,2.818h-1.308Zm-.036-5.469c0-1.2-.804-1.883-2.339-1.883h-2.039v3.778h2.039c1.535,0,2.339-.695,2.339-1.895Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.854,207.778v1.043h-6.093v-8.395h5.925v1.043h-4.726v2.579h4.21v1.02h-4.21v2.71h4.894Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.15,206.723h-4.461l-.924,2.099h-1.235l3.802-8.395h1.187l3.814,8.395h-1.259l-.923-2.099Zm-.42-.959l-1.811-4.114-1.811,4.114h3.622Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.832,201.47h-2.878v-1.043h6.944v1.043h-2.878v7.352h-1.188v-7.352Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.209,200.426h1.199v8.395h-1.199v-8.395Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.137,200.426l-3.682,8.395h-1.187l-3.694-8.395h1.295l3.023,6.896,3.046-6.896h1.199Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.209,200.426h1.199v8.395h-1.199v-8.395Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.596,201.47h-2.878v-1.043h6.944v1.043h-2.878v7.352h-1.188v-7.352Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.091,205.919v2.902h-1.188v-2.926l-3.334-5.469h1.283l2.687,4.426,2.698-4.426h1.188l-3.334,5.493Z",
    style: {
      fill: "#071530"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_3--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.631,192.21c-5.602,0-10.16-4.553-10.16-10.149V93.88c0-5.597,4.558-10.149,10.16-10.149h106.28c5.597,0,10.15,4.553,10.15,10.149v88.181c0,5.597-4.553,10.149-10.15,10.149h-106.28Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.631,192.21c-5.602,0-10.16-4.553-10.16-10.149V93.88c0-5.597,4.558-10.149,10.16-10.149h106.28c5.597,0,10.15,4.553,10.15,10.149v88.181c0,5.597-4.553,10.149-10.15,10.149h-106.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.061,93.88v88.18c0,4.5-3.65,8.15-8.15,8.15h-106.28c-4.51,0-8.16-3.65-8.16-8.15V93.88c0-4.5,3.65-8.15,8.16-8.15h106.28c4.5,0,8.15,3.65,8.15,8.15Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.199,
    cy: 100.981,
    r: 36.24,
    transform: "translate(-9.627 153.565) rotate(-22.5)",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.199,
    cy: 100.981,
    r: 36.24,
    transform: "translate(-9.627 153.565) rotate(-22.5)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.199,
    cy: 100.981,
    r: 29.495,
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.199,
    cy: 100.981,
    r: 29.495,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.542,162.443c2.99,1.054,6.113,2.134,9.15,3.024,1.526,.429,3.046,.837,4.496,1.117,.72,.133,1.426,.238,2.032,.285,.309,.028,.57,.024,.77,.019,.107-.007,.126-.005,.233-.018,.115-.025,.235-.048,.315-.074,.176-.049,.275-.086,.294-.085,.023,0,.024,.039,.079-.014,.114-.083,.326-.613,.452-1.276,.281-1.344,.427-3.052,.635-4.704,.21-1.67,.44-3.365,.709-5.048,.304-1.681,.619-3.358,1.039-5.011,.239-.939,1.193-1.507,2.132-1.268,.798,.203,1.328,.923,1.322,1.711v.008c-.012,1.654-.053,3.296-.028,4.939-.013,1.641,.012,3.277,.055,4.938,.018,1.677,.087,3.311-.086,5.274-.117,.979-.249,2.119-.971,3.489-.359,.671-.909,1.355-1.545,1.867-.64,.517-1.303,.844-1.906,1.086-.309,.126-.592,.214-.878,.302-.297,.083-.688,.173-.994,.221-.627,.096-1.201,.136-1.726,.141-1.062,.018-2.017-.066-2.946-.181-1.847-.234-3.58-.588-5.276-1.021-3.405-.849-6.622-1.871-9.88-3.157-1.807-.713-2.693-2.755-1.98-4.561,.696-1.764,2.659-2.65,4.433-2.028l.07,.025Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.099,162.588c5.911-3.329,12.021,2.016,21.216,3.953l2.425,7.209s-8.943,2.18-17.599-2.252c-8.656-4.432-6.042-8.91-6.042-8.91Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.741,173.751s-1.11,.27-2.95,.43c-1.81,.15-4.3,.19-7.1-.26-1.34-.21-2.75-.54-4.19-1.02-1.11-.37-2.24-.83-3.36-1.4-.2-.1-.4-.21-.58-.31-7.95-4.33-5.46-8.6-5.46-8.6,5.91-3.33,12.02,2.01,21.21,3.96l2.43,7.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.629,165.94l1.296-.574,4.603,7.147-2.633,3.011s-4.127-5.758-3.265-9.584Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.629,165.94l1.296-.574,4.603,7.147-2.633,3.011s-4.127-5.758-3.265-9.584Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.501,172.901c-1.11-.37-2.24-.83-3.36-1.4-.2-.1-.4-.21-.58-.31-.25-1.84-.36-3.62-.27-5.14,0,0,2.47,2.77,4.21,6.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.515,138.82c-.394-1.754,4.931-6.271,8.081-6.386s2.027,1.71,4.03,1.012,4.597-.922,5.71,.688-.781,4.766,1.227,5.036c2.008,.27,4.94,1.964,3.522,4.621-1.417,2.658-6.615,7.923-13.098,9.677-6.483,1.753-10.249-6.195-10.254-9.218,0,0-2.217-.072-1.885,2.342,.332,2.414,3.688,3.451,2.805,5.782-.884,2.331-1.774,3.537,.571,4.69,2.345,1.153,.667,4.412-.937,4.541,0,0,.752-.366,.118-1.531s-2.917,.522-5.034-2.319c-2.118-2.841,.178-3.932-1.025-5.094-1.203-1.161-3.037-.059-3.957-2.873-.671-2.052,1.819-4.683,2.186-6.358,.367-1.674-1.371-1.869-.739-4.879,.421-2.004,3.489-2.787,5.202-2.545,2.974,.421,3.476,2.812,3.476,2.812Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.619,172.233c-7.345-6.151-16.352-10.073-16.352-10.073,.513-.089,1.042-.172,1.572-.247,3.988-.557,7.256-.983,10.84-.984,.902,.001,1.827,.024,2.738,.047v.007c2.54,5.018,1.203,11.248,1.203,11.248Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360.781,190.21h-24.76c-.59-2.53-1.35-5.42-2.28-8.51-.12-.42-.25-.85-.39-1.28-.13-.43-.27-.87-.41-1.31v-.01c-.17-.53-.34-1.07-.53-1.62-.13-.39-.26-.79-.4-1.19v-.01c-.07-.19-.13-.39-.19-.58-.3-.87-.61-1.75-.93-2.63-.07-.21-.15-.41-.23-.62v-.01c-.28-.78-.57-1.56-.88-2.35-.66-1.71-.83-3.18-.84-4.21,0-1.04,.15-1.64,.15-1.64,0,0,3.48-1.22,5.22-1.79,.07-.02,.15-.05,.22-.07,.38-.13,.64-.21,.73-.22h.01c.14-.03,.29-.05,.43-.07,.37-.07,.75-.13,1.14-.18l.63-.09c3.52-.48,6.51-.85,9.71-.88,.16-.01,.33-.01,.5-.01,.45,0,.91,.01,1.37,.01,.45,.01,.91,.03,1.36,.04h.01c.03,0,.1,.01,.19,.01,.04,0,.08,.01,.13,.01,.07,.01,.15,.02,.23,.03h.06c1.11,.11,3.41,.35,4.51,.46,.11,.01,.21,.02,.3,.03,.03,0,.07,0,.1,.01h.01c.1,.01,.17,.01,.2,.01v.01l.01,.01c.05,.07,.28,.41,.61,.96,.26,.44,.59,1.01,.93,1.67,.7,1.37,1.44,3.11,1.8,4.91,.06,.29,.1,.59,.14,.88,.02,.15,.04,.29,.05,.43,.03,.21,.05,.41,.09,.61,.06,.43,.12,.86,.19,1.32,.06,.47,.13,.97,.19,1.54,.16,1.4,.31,3.2,.4,5.83,.01,.24,.02,.5,.04,.79,.01,.29,.02,.59,.03,.92,.01,.32,.02,.66,.03,1.01,.01,.36,.02,.73,.02,1.12,.01,.38,.02,.76,.03,1.16,.03,1.87,.06,3.85,.07,5.5Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.781,190.21h-24.76c-.59-2.53-1.35-5.42-2.28-8.51-.13-.42-.26-.85-.39-1.28-.13-.44-.27-.87-.41-1.31v-.01c-.17-.53-.35-1.07-.53-1.62-.13-.39-.26-.79-.4-1.19v-.01c-.07-.19-.13-.39-.19-.58-.3-.86-.61-1.73-.93-2.61-.07-.21-.15-.43-.23-.64v-.01c-.28-.78-.57-1.56-.88-2.35-.66-1.71-.83-3.18-.84-4.21,0-1.04,.15-1.64,.15-1.64,0,0,3.48-1.22,5.22-1.79,.08-.03,.15-.05,.22-.07,.38-.13,.64-.21,.73-.22h.01c.14-.03,.29-.05,.43-.07,.37-.07,.75-.13,1.14-.18l.63-.09c3.52-.48,6.51-.85,9.71-.88,.16-.01,.33-.01,.5-.01,.45,0,.91,.01,1.37,.01,.45,.01,.91,.02,1.37,.03,.03,0,.09,.01,.19,.02,.04,0,.08,.01,.13,.01,.06,.01,.14,.01,.22,.02,.02,0,.05,.01,.07,.01,1.11,.11,3.41,.35,4.51,.46,.11,.01,.21,.02,.3,.03,.02,0,.04,0,.06,.01h.05c.1,.01,.17,.02,.2,.02l.01,.01c.05,.07,.28,.41,.61,.96,.26,.44,.59,1.01,.93,1.67,.68,1.36,1.42,3.09,1.78,4.88,.06,.3,.11,.61,.15,.91,.02,.15,.04,.29,.06,.43,.03,.21,.05,.41,.09,.61,.06,.43,.12,.86,.19,1.32,.06,.47,.13,.97,.19,1.54,.17,1.4,.32,3.2,.41,5.83,.01,.24,.02,.5,.03,.79,.01,.29,.02,.59,.03,.92,.01,.32,.02,.66,.03,1.01,.01,.36,.02,.73,.02,1.12,.01,.38,.02,.77,.03,1.16,.03,1.87,.06,3.85,.07,5.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.104,171.42c.011,.204-.144,.379-.349,.391-.204,.012-.379-.144-.39-.349s.144-.379,.349-.391,.379,.145,.39,.349Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.898,179.16c.012,.204-.144,.379-.349,.391-.204,.012-.379-.145-.39-.349-.012-.204,.144-.379,.349-.39,.204-.012,.379,.144,.39,.348Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.691,186.597c.011,.204-.145,.379-.349,.39-.204,.012-.379-.144-.39-.348-.012-.204,.144-.379,.349-.391,.204-.012,.379,.145,.391,.349Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.226,159.003c9.659-.576,13.2,6.587,13.2,6.587l-4.595-.668s-1.125,4.19-2.536,5.399c0,0-5.891-1.032-8.961-3.992l-4.127,1.395s-2.685-8.143,7.019-8.722Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.226,159.003c9.659-.576,13.2,6.587,13.2,6.587l-4.595-.668s-1.125,4.19-2.536,5.399c0,0-5.891-1.032-8.961-3.992l-4.127,1.395s-2.685-8.143,7.019-8.722Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.167,162.382c1.383,4.11-.872,7.94-.872,7.94-7.448-1.891-10.858-8.461-10.858-8.461,2.05-2.536,.311-8.817-.95-12.225l3.053,2.028,4.544,3.011c-.064,.733,.09,1.723,.362,2.67,.408,1.367,1.074,2.637,1.741,2.877l2.978,2.16Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.447,157.345c-1.76-.291-4.139-1.959-4.607-3.713-.192-.74-.301-1.471-.3-1.967l4.544,3.011c-.064,.733,.09,1.723,.362,2.67Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.413,146.429c2.938,4.948,4.074,7.098,8.036,8.539,5.959,2.168,11.483-2.147,10.104-7.781-1.241-5.071-5.837-12.31-11.951-12.066-6.024,.241-9.127,6.36-6.189,11.308Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.521,144.837c.229,.426,.641,.669,.921,.543,.28-.126,.322-.574,.093-1-.229-.426-.641-.669-.921-.542-.28,.126-.322,.574-.093,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.898,142.21c.229,.426,.641,.669,.921,.542,.28-.126,.322-.574,.093-1-.229-.426-.641-.669-.921-.542-.28,.126-.322,.574-.093,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.88,141.289l.871-.759s-.099,1.037-.871,.759Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.736,143.897s1.711,1.506,2.986,2.03c-.284,.78-1.374,.974-1.374,.974l-1.612-3.003Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.283,142.53c.069-.024,.127-.075,.156-.147,.446-1.118,1.466-1.286,1.478-1.288,.151-.025,.25-.164,.216-.314-.034-.15-.187-.252-.341-.229-.053,.009-1.335,.219-1.888,1.606-.055,.138,.02,.301,.167,.363,.071,.03,.146,.031,.211,.008Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.629,138.398c.068-.014,.13-.053,.168-.114,.08-.126,.035-.296-.1-.382-1.358-.856-2.545-.382-2.595-.361-.141,.058-.199,.219-.129,.359,.07,.14,.24,.206,.381,.148,.046-.019,.973-.373,2.052,.307,.07,.044,.15,.057,.222,.042Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.503,143.916l.871-.759s-.099,1.037-.871,.759Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.163,148.624s1.374-4.681-2.477-9.685c0,0,4.994-4.817,10.926-1.894,0,0-6.578-5.969-14.163,.399-7.585,6.368,1.74,12.6,3.049,12.944,1.309,.344,2.665-1.765,2.665-1.765Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.856,151.39c1.116,.77,2.427,.963,3.446,.758,1.533-.309,1.47-1.938,.349-3.087-1.009-1.035-3.022-2.121-4.227-1.217-1.187,.891-.845,2.665,.432,3.546Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.063,148.039c-.112,.849-.02,2.346-.02,2.346-.134,.033-.268,.066-.404,.091-1.831,.399-2.812-.021-3.344-.607-.29-.322-.443-.699-.525-1.016-.099-.366-.086-.649-.086-.649,1.097,.368,2.832,.128,3.753-.039,.386-.066,.626-.126,.626-.126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.437,148.166l-.024,.692c-1.725,.372-2.989,.402-3.643-.003-.099-.366-.086-.649-.086-.649,1.097,.368,2.832,.128,3.753-.039Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.639,150.477c-1.831,.399-2.812-.021-3.344-.607,.629-.112,1.4-.177,2.12-.04,.551,.102,.94,.361,1.224,.647Z",
    style: {
      fill: "#de5753"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379.536,152.922l5.153-2.037-4.503-4.182s-4.488,2.095-3.311,4.362l2.662,1.857Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.77 146.621 382.906 144.226 380.186 146.703 384.689 150.885 387.77 146.621",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.939,179.113c-.683-2.155-1.441-4.385-2.281-6.661,.576-.974,1.269-1.815,2.069-2.371,0,0,1.78,5.598,.212,9.033Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.741,170.42l-.02,.05c-.09,.27-.17,.54-.26,.82-.19,.59-.38,1.18-.57,1.78v.02c-.56,1.77-1.11,3.57-1.63,5.34-.77,2.64-1.54,5.35-1.92,7.78-.04,.26-.08,.51-.1,.75-.03,.3-.05,.57-.05,.76,0,.08,0,.1-.01,.15,.01,.03-.01,.04,.01,.11,0,.02,.01,.06,.02,.09,.03,.11,.09,.25,.15,.4,.08,.2,.19,.41,.32,.63,.21,.36,.46,.73,.74,1.11h-7.1c-.03-.04-.04-.09-.06-.13-.1-.22-.18-.51-.25-.79-.02-.04-.03-.09-.04-.13-.06-.3-.12-.63-.15-.9-.05-.47-.07-.9-.07-1.3,0-.52,.03-.99,.06-1.47,.3-3.24,.97-6.06,1.68-8.93,.75-2.84,1.59-5.59,2.58-8.38,.58-1.62,2.22-2.56,3.87-2.3,.2,.03,.41,.09,.62,.16,1.79,.64,2.75,2.58,2.18,4.38Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.09,164.238c-2.865,.673-5.086,4.043-6.958,10.359-1.872,6.317-2.894,12.189-1.787,14.827l7.659-1.512s1.55-7.403,4.009-11.627c0,0,1.162-5.467,.109-8.505s-3.032-3.544-3.032-3.544Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.09,164.238c-2.865,.673-5.086,4.043-6.958,10.359-1.872,6.317-2.894,12.189-1.787,14.827l7.659-1.512s1.55-7.403,4.009-11.627c0,0,1.162-5.467,.109-8.505s-3.032-3.544-3.032-3.544Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.531,188.88l-.85,.22-4.34,1.11h-3.5l-1.57-2.67s.65-.2,1.64-.42c.26-.05,.54-.11,.84-.16,1.88-.36,4.48-.62,6.49,0,.31,.1,.61,.22,.89,.37,.09,.04,.18,.09,.27,.14l.13,1.41Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.531,188.88l-.85,.22-4.34,1.11h-3.5l-1.57-2.67s.65-.2,1.64-.42c.26-.05,.54-.11,.84-.16,1.88-.36,4.48-.62,6.49,0,.31,.1,.61,.22,.89,.37,.09,.04,.18,.09,.27,.14l.13,1.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light_bulb--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M389.775,133.984c.02,2.72-3.695,4.952-8.297,4.986-4.603,.034-8.35-2.143-8.37-4.863-.02-2.72,3.695-4.952,8.297-4.986,4.603-.034,8.35,2.143,8.37,4.863Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.775,133.984c.02,2.72-3.695,4.952-8.297,4.986-4.603,.034-8.35-2.143-8.37-4.863-.02-2.72,3.695-4.952,8.297-4.986,4.603-.034,8.35,2.143,8.37,4.863Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.308,124.93c.472-.512,.741-1.059,.737-1.63-.02-2.67-5.714-4.793-12.719-4.741-7.005,.052-12.667,2.259-12.647,4.929,.004,.571,.281,1.114,.761,1.619-.133,.278-.21,.562-.208,.854,.004,.565,.286,1.101,.775,1.598-.146,.283-.224,.576-.222,.875,.004,.561,.293,1.093,.796,1.584-.158,.287-.245,.584-.243,.889,.004,.559,.299,1.088,.82,1.573-.171,.29-.269,.591-.267,.9,.016,2.22,4.751,3.985,10.574,3.942s10.531-1.878,10.514-4.098c-.002-.309-.105-.608-.28-.896,.513-.492,.801-1.026,.797-1.585-.002-.305-.093-.6-.256-.885,.496-.498,.777-1.035,.772-1.596-.002-.299-.084-.59-.235-.872,.482-.504,.756-1.044,.751-1.609-.002-.291-.083-.575-.221-.851Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.643,101.15c-.096-12.923-11.093-23.214-24.203-22.212-11.31,.865-20.301,10.279-20.674,21.615-.243,7.369,3.064,13.958,8.329,18.216,.955,.773,1.496,1.954,1.385,3.178-.005,.06-.008,.12-.007,.18,.02,2.712,5.803,4.867,12.916,4.815,7.113-.053,12.863-2.294,12.843-5.006,0-.058-.004-.116-.01-.174-.127-1.237,.412-2.43,1.365-3.227,4.966-4.153,8.108-10.407,8.056-17.386Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.643,101.15c-.096-12.923-11.093-23.214-24.203-22.212-11.31,.865-20.301,10.279-20.674,21.615-.243,7.369,3.064,13.958,8.329,18.216,.955,.773,1.496,1.954,1.385,3.178-.005,.06-.008,.12-.007,.18,.02,2.712,5.803,4.867,12.916,4.815,7.113-.053,12.863-2.294,12.843-5.006,0-.058-.004-.116-.01-.174-.127-1.237,.412-2.43,1.365-3.227,4.966-4.153,8.108-10.407,8.056-17.386Z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.743,123.843c-.441,0-.8-.355-.803-.797-.057-7.741-6.32-13.646-6.384-13.705-.241-.224-.322-.573-.202-.88,.119-.306,.413-.509,.742-.512l3.693-.028,1.124-2.695c.118-.284,.39-.476,.697-.493,.329-.012,.599,.145,.747,.414l2.111,3.819,2.054-3.851c.143-.266,.46-.411,.723-.425,.301,.006,.575,.18,.708,.451l2.095,4.296,2.031-4.325c.135-.285,.457-.478,.739-.462,.316,.005,.599,.194,.725,.483l1.163,2.679,3.694-.028h.006c.36,0,.677,.24,.773,.587,.097,.35-.051,.721-.363,.906-5.255,3.121-6.739,13.702-6.753,13.808-.06,.44-.459,.744-.903,.688-.44-.059-.748-.463-.69-.902,.056-.412,1.261-9.032,5.623-13.464l-1.907,.014c-.378-.019-.615-.188-.742-.483l-.667-1.536-1.989,4.236c-.132,.28-.412,.46-.721,.462-.321-.02-.592-.173-.728-.451l-2.141-4.39-2.01,3.767c-.139,.259-.408,.423-.703,.425-.29,.1-.566-.156-.709-.415l-2.022-3.657-.688,1.65c-.124,.297-.413,.491-.736,.494l-2.381,.018c1.991,2.301,5.549,7.28,5.595,13.493,.003,.443-.353,.806-.797,.809h-.006Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Communication--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.872,204.624c0-2.482,1.895-4.293,4.45-4.293,1.295,0,2.422,.444,3.19,1.307l-.779,.755c-.648-.684-1.439-.995-2.363-.995-1.895,0-3.298,1.367-3.298,3.226s1.403,3.226,3.298,3.226c.923,0,1.715-.324,2.363-1.007l.779,.756c-.768,.863-1.895,1.319-3.202,1.319-2.543,0-4.438-1.811-4.438-4.293Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.368,204.624c0-2.458,1.895-4.293,4.474-4.293,2.555,0,4.45,1.823,4.45,4.293s-1.895,4.293-4.45,4.293c-2.579,0-4.474-1.835-4.474-4.293Zm7.724,0c0-1.859-1.391-3.226-3.25-3.226-1.883,0-3.274,1.367-3.274,3.226s1.391,3.226,3.274,3.226c1.859,0,3.25-1.367,3.25-3.226Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.915,208.822l-.012-6.117-3.035,5.097h-.552l-3.034-5.061v6.081h-1.151v-8.395h.983l3.502,5.901,3.454-5.901h.984l.012,8.395h-1.151Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.375,208.822l-.012-6.117-3.035,5.097h-.552l-3.034-5.061v6.081h-1.151v-8.395h.983l3.502,5.901,3.454-5.901h.984l.012,8.395h-1.151Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.979,205.2v-4.773h1.199v4.725c0,1.859,.852,2.698,2.363,2.698s2.374-.839,2.374-2.698v-4.725h1.164v4.773c0,2.435-1.332,3.718-3.55,3.718-2.207,0-3.55-1.283-3.55-3.718Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.763,200.427v8.395h-.983l-5.038-6.261v6.261h-1.199v-8.395h.983l5.037,6.261v-6.261h1.2Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287,200.427h1.199v8.395h-1.199v-8.395Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.323,204.624c0-2.482,1.895-4.293,4.45-4.293,1.295,0,2.422,.444,3.19,1.307l-.779,.755c-.648-.684-1.44-.995-2.363-.995-1.895,0-3.298,1.367-3.298,3.226s1.403,3.226,3.298,3.226c.923,0,1.715-.324,2.363-1.007l.779,.756c-.768,.863-1.895,1.319-3.202,1.319-2.542,0-4.438-1.811-4.438-4.293Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.828,206.724h-4.461l-.924,2.099h-1.235l3.802-8.395h1.187l3.814,8.395h-1.259l-.923-2.099Zm-.42-.959l-1.811-4.114-1.811,4.114h3.622Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,201.47h-2.878v-1.043h6.944v1.043h-2.878v7.352h-1.188v-7.352Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.887,200.427h1.199v8.395h-1.199v-8.395Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.923,204.624c0-2.458,1.895-4.293,4.474-4.293,2.555,0,4.449,1.823,4.449,4.293s-1.895,4.293-4.449,4.293c-2.579,0-4.474-1.835-4.474-4.293Zm7.724,0c0-1.859-1.391-3.226-3.25-3.226-1.883,0-3.274,1.367-3.274,3.226s1.392,3.226,3.274,3.226c1.859,0,3.25-1.367,3.25-3.226Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.907,200.427v8.395h-.983l-5.038-6.261v6.261h-1.199v-8.395h.983l5.037,6.261v-6.261h1.2Z",
    style: {
      fill: "#071530"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters_2--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.099,192.22c-4.417,0-8.301-2.822-9.663-7.023-.158-.448-.287-.967-.381-1.544,0,0-.025-.241-.033-.289l-.027-.161-.002-.071c-.033-.357-.054-.704-.054-1.072V93.88c0-5.597,4.558-10.15,10.16-10.15h106.28c5.597,0,10.15,4.553,10.15,10.15v88.18c0,2.502-.931,4.92-2.58,6.764v.048l-.627,.602c-1.874,1.771-4.34,2.746-6.943,2.746H86.099Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.099,192.22c-4.417,0-8.301-2.822-9.663-7.023-.158-.448-.287-.967-.381-1.544,0,0-.025-.241-.033-.289l-.027-.161-.002-.071c-.033-.357-.054-.704-.054-1.072V93.88c0-5.597,4.558-10.15,10.16-10.15h106.28c5.597,0,10.15,4.553,10.15,10.15v88.18c0,2.502-.931,4.92-2.58,6.764v.048l-.627,.602c-1.874,1.771-4.34,2.746-6.943,2.746H86.099Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,93.88v88.18c0,2.35-.99,4.47-2.58,5.95v.01c-1.45,1.37-3.42,2.2-5.57,2.2H86.099c-3.63,0-6.7-2.37-7.76-5.64-.14-.4-.24-.82-.31-1.25-.01-.11-.02-.22-.04-.33v-.01c-.03-.31-.05-.61-.05-.93V93.88c0-4.5,3.65-8.15,8.16-8.15h106.28c4.5,0,8.15,3.65,8.15,8.15Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.916,157.941c1.205,3.035,2.498,6.181,3.849,9.158,.701,1.478,1.418,2.929,2.163,4.293,.383,.655,.774,1.303,1.159,1.86,.194,.325,.376,.49,.556,.744l.133,.174,.1,.09c.064,.062,.124,.13,.181,.205,.026,.018-.144-.07-.187-.066-.048-.028-.133-.006-.114-.012,0,0-.012,.014-.003,.021,.022-.001,.045,0,.067,.006,.029,.023,.139,.005,.222,.009,.389-.013,1.015-.177,1.648-.421,1.287-.495,2.701-1.252,4.069-2.092,1.39-.825,2.768-1.752,4.122-2.727,1.368-.949,2.734-1.981,4.053-2.968l.055-.041c.829-.62,2.005-.451,2.625,.378,.524,.701,.483,1.649-.042,2.3-2.258,2.801-4.708,5.298-7.51,7.665-1.428,1.153-2.909,2.282-4.747,3.226-.928,.466-1.927,.915-3.236,1.179-.343,.056-.656,.127-1.059,.135l-.577,.017c-.205-.006-.429-.032-.643-.055-.415-.03-.903-.168-1.362-.319-.437-.153-.99-.457-1.314-.678-1.164-.841-1.94-1.687-2.598-2.485-.669-.803-1.201-1.604-1.74-2.401-1.023-1.584-1.903-3.18-2.716-4.787-1.624-3.22-3.017-6.41-4.228-9.811-.698-1.96,.326-4.114,2.285-4.811,1.915-.681,4.015,.28,4.761,2.152l.025,.064Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.666,154.462c6.852,2.418,6.852,11.113,11.774,19.892l-4.102,7.038s-8.064-5.672-10.595-15.776c-2.531-10.104,2.923-11.154,2.923-11.154Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.435,174.357l-4.092,7.037s-1.007-.707-2.431-2.078c-1.393-1.35-3.192-3.331-4.798-5.902-1.371-2.185-2.614-4.799-3.374-7.798-2.528-10.1,2.924-11.15,2.924-11.15,6.855,2.41,6.855,11.107,11.772,19.89Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,173.378l1.376,.64-2.516,8.751h-4.284s1.732-7.387,5.424-9.391Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,173.378l1.376,.64-2.516,8.751h-4.284s1.732-7.387,5.424-9.391Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.912,179.316c-1.393-1.35-3.192-3.331-4.798-5.902-.129-2.603-.043-5.163,.343-7.23,0,0,4.145,6.019,4.456,13.132Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.786,136.655c-.407,.386-.953,.825-1.628,1.275-1.36,.9-3.213,1.864-5.366,2.646-.407,.15-.814,.289-1.242,.418-.353,.118-.718,.225-1.092,.321,0,0,0-.011-.011,0-1.575,.428-3.245,.728-4.959,.814-.557,.032-1.114,.043-1.671,.032-.193,0-.386-.011-.579-.021-.107-.011-.225-.011-.332-.021-6.887-.632-8.033-9.736-7.048-12.767,0,0-2.228-.814-2.699,1.757-.461,2.56,2.613,4.734,.932,6.812-1.671,2.078-2.978,3.01-.975,4.97,2.003,1.949-.792,4.713-2.463,4.306,0,0,.889-.118,.632-1.51-.15-.835-1.232-.835-2.346-1.446v-18.283c.718-1.467-.803-2.292,.782-5.034,1.093-1.907,4.477-1.682,6.137-.868,2.892,1.425,2.603,4.027,2.603,4.027,.182-1.917,7.112-4.745,10.357-3.813,3.245,.932,1.489,2.41,3.77,2.367,2.271-.043,4.981,.589,5.58,2.603,.6,2.014-2.378,4.595-.428,5.538,1.96,.943,4.38,3.642,2.046,5.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.168,165.617c-7.481-7.023-16.875-11.764-16.875-11.764,.554-.064,1.125-.12,1.696-.169,4.299-.353,7.819-.611,11.652-.394,.964,.056,1.953,.137,2.925,.217v.008c2.411,5.521,.603,12.102,.603,12.102Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.138,190.45h-3.593l-.018-.459,2.753-.214c.259-.021,.509,.107,.642,.323l.216,.351Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.305,171.862c0,.696,0,1.457-.021,2.292,0,.471-.021,1.028-.032,1.66-.011,.525-.032,1.103-.054,1.714-.128,3.963-.386,9.222-.482,11.15-.021,.482-.032,.75-.032,.75-.054,.3-.15,.568-.279,.793h-25.139c-.021-.321-.054-.653-.097-1.007-.075-.61-.15-1.264-.246-1.96-.032-.236-.064-.471-.107-.707-.204-1.435-.472-3.021-.803-4.724v-.011c-.332-1.757-.728-3.631-1.178-5.613-.118-.503-.236-1.017-.364-1.542-.107-.46-.225-.932-.343-1.403-.107-.461-.236-.943-.354-1.414-.257-1.018-.535-2.056-.825-3.106-.246-.889-.503-1.789-.771-2.699v-.021c-.15-.482-.289-.953-.439-1.435-.246-.857-.514-1.714-.793-2.581-.075-.246-.15-.493-.203-.728-.086-.289-.15-.578-.203-.846-.011-.064-.032-.139-.032-.204-.054-.278-.096-.546-.128-.803-.096-.771-.096-1.435-.075-1.992,.021-.3,.043-.568,.075-.793,.021-.139,.043-.257,.053-.364,0-.011,0-.021,.011-.032,.032-.182,.064-.311,.085-.396,0-.032,.011-.053,.021-.075,0-.021,.011-.043,.011-.054l.011-.011c.311-.096,6.223-1.789,6.716-1.842,.15-.021,.311-.032,.471-.053,.407-.043,.814-.086,1.232-.118,.225-.021,.45-.032,.664-.053,1.36-.107,2.646-.214,3.888-.279,.204-.011,.407-.032,.61-.032,.514-.032,1.018-.054,1.521-.075,.707-.021,1.403-.032,2.11-.032h.107c.429,0,.857,.011,1.296,.021,.3,.011,.6,.021,.91,.032,.182,0,.364,.011,.546,.021,.964,.054,1.949,.139,2.924,.214,.054,.011,.268,.043,.578,.086,1.478,.236,5.27,.857,5.516,.878l.011,.011c.043,.086,.289,.493,.643,1.146v.011c.878,1.671,2.346,4.916,2.56,8.065,.139,2.164,.439,3.877,.429,8.162Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.305,171.862c0,.696,0,1.457-.021,2.292,0,.471-.021,1.028-.032,1.66-.011,.525-.032,1.103-.054,1.714-.128,3.963-.386,9.222-.482,11.15-.021,.482-.032,.75-.032,.75-.054,.3-.15,.568-.279,.793h-25.139c-.021-.321-.054-.653-.097-1.007-.064-.61-.15-1.264-.246-1.96-.032-.236-.064-.471-.107-.707-.204-1.435-.472-3.021-.803-4.724v-.011c-.332-1.757-.728-3.631-1.178-5.613-.118-.503-.236-1.017-.364-1.542-.107-.46-.225-.932-.343-1.403-.107-.461-.236-.943-.354-1.414-.257-1.018-.535-2.056-.825-3.106-.246-.889-.503-1.789-.771-2.699v-.021c-.15-.482-.289-.953-.439-1.435-.246-.857-.514-1.714-.793-2.581-.075-.246-.15-.493-.203-.728-.086-.289-.15-.578-.203-.846-.011-.064-.032-.139-.032-.204-.054-.278-.096-.546-.128-.803-.096-.771-.096-1.435-.075-1.992,.021-.3,.043-.568,.075-.793,.021-.139,.043-.257,.053-.364,0-.011,0-.021,.011-.032,.021-.171,.053-.3,.085-.396,0-.032,.011-.053,.021-.075,0-.021,.011-.043,.011-.054l.011-.011c.311-.096,6.223-1.789,6.716-1.842,.15-.021,.311-.032,.471-.053,.407-.043,.814-.086,1.232-.118,.225-.021,.45-.032,.664-.053,1.36-.107,2.646-.214,3.888-.279,.204-.011,.407-.032,.61-.032,.514-.032,1.018-.054,1.521-.075,.707-.021,1.403-.032,2.11-.032h.107c.429,0,.857,.011,1.296,.021,.3,.011,.6,.021,.91,.032,.182,0,.364,.011,.546,.021,.964,.054,1.949,.139,2.924,.214,.054,.011,.268,.043,.578,.086,1.478,.236,5.27,.857,5.516,.878l.011,.011c.043,.086,.289,.493,.643,1.146v.011c.878,1.671,2.346,4.916,2.56,8.065,.139,2.164,.439,3.877,.429,8.162Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.529,164.595c0,.219-.177,.397-.396,.397s-.396-.178-.396-.397,.177-.396,.396-.396,.396,.177,.396,.396Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.581,
    cy: 172.981,
    r: 0.396,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.977,
    cy: 180.982,
    r: 0.396,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.373,
    cy: 188.681,
    r: 0.396,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.928,150.899c10.365-.029,13.716,7.846,13.716,7.846l-4.874-.993s-1.458,4.412-3.04,5.619c0,0-6.237-1.461-9.34-4.813l-4.498,1.241s-2.377-8.871,8.035-8.9Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.928,150.899c10.365-.029,13.716,7.846,13.716,7.846l-4.874-.993s-1.458,4.412-3.04,5.619c0,0-6.237-1.461-9.34-4.813l-4.498,1.241s-2.377-8.871,8.035-8.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.144,154.934c1.229,4.48-1.414,8.438-1.414,8.438-7.85-2.475-11.097-9.707-11.097-9.707,2.346-2.587,.868-9.41-.273-13.13l3.142,2.355,4.677,3.495c-.112,.779-.008,1.848,.225,2.877,.353,1.486,.988,2.885,1.687,3.182l3.054,2.491Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.403,149.261c-1.864-.418-4.307-2.347-4.701-4.251-.161-.803-.233-1.591-.201-2.121l4.677,3.495c-.112,.779-.008,1.848,.225,2.877Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.902,133.121c1.344,6.015,1.785,8.582,5.339,11.368,5.345,4.19,12.405,1.636,12.877-4.559,.425-5.576-1.845-14.475-8.151-16.261-6.213-1.759-11.408,3.438-10.064,9.452Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.668,133.866c.091,.51,.43,.894,.757,.859s.519-.477,.427-.987c-.091-.51-.43-.894-.757-.859-.327,.035-.519,.477-.428,.987Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.017,132.981c.091,.51,.43,.894,.757,.859,.327-.035,.519-.477,.428-.987-.091-.51-.43-.894-.757-.859s-.519,.477-.428,.987Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.305,132.038l1.139-.483s-.446,1.023-1.139,.483Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.272,134.312s1.241,2.102,2.365,3.06c-.549,.699-1.723,.534-1.723,.534l-.641-3.594Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.157,130.773c.079-.001,.154-.034,.207-.097,.825-.989,1.921-.821,1.933-.819,.162,.025,.309-.084,.324-.248,.015-.164-.106-.319-.271-.346-.057-.009-1.432-.222-2.456,1.007-.102,.122-.08,.313,.05,.425,.062,.054,.139,.08,.212,.079Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.029,129.344c.074,.008,.15-.011,.209-.06,.123-.101,.134-.29,.025-.422-1.097-1.323-2.464-1.235-2.522-1.231-.163,.012-.276,.157-.251,.322,.024,.165,.176,.29,.339,.278,.053-.004,1.115-.056,1.987,.996,.056,.068,.134,.108,.212,.116Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.956,132.923l1.139-.483s-.446,1.023-1.139,.483Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.989,136.605s2.957-4.308,.702-10.684c0,0,6.688-3.242,11.753,1.708,0,0-4.711-8.266-14.551-4.307-9.841,3.959-2.422,13.407-1.204,14.193,1.218,.786,3.3-.909,3.3-.909Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.702,138.32c.88,1.155,2.15,1.788,3.256,1.919,1.663,.196,2.141-1.484,1.383-3.027-.683-1.389-2.371-3.165-3.898-2.645-1.504,.512-1.747,2.432-.74,3.753Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.263,139.304c-.397,.827-.802,2.382-.802,2.382-.148-.011-.295-.023-.442-.042-1.996-.203-2.856-.957-3.202-1.731-.188-.424-.218-.859-.196-1.209,.021-.405,.128-.689,.128-.689,.994,.74,2.841,1.073,3.834,1.209,.415,.061,.68,.08,.68,.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.583,139.224l-.255,.696c-1.88-.196-3.177-.586-3.708-1.216,.021-.405,.128-.689,.128-.689,.994,.74,2.841,1.073,3.834,1.209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.02,141.644c-1.996-.203-2.856-.957-3.202-1.731,.678,.096,1.484,.286,2.172,.665,.527,.288,.837,.681,1.03,1.066Z",
    style: {
      fill: "#de5753"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.43,173.692l5.368-2.531-.036,6.583s-4.926,1.969-5.834-.612l.501-3.44Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.644 171.786 108.691 177.435 104.763 177.743 104.799 171.161 110.644 171.786",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.043,169.422l5.783-1.334-4.101-5.149s-5.088,1.502-4.204,4.09l2.522,2.392Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.769 164.065 145.001 160.751 141.724 162.94 145.826 168.088 149.769 164.065",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.775,171.84c-.6-2.346-1.274-4.777-2.035-7.262,.675-1.007,1.467-1.864,2.356-2.41,0,0,1.564,6.095-.321,9.672Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.535,174.989c-.225-.868-1.007-1.435-1.853-1.414h-.011c-.139,0-.279,.021-.418,.064l-.064,.011c-1.617,.418-3.288,.878-4.949,1.242-1.65,.407-3.299,.771-4.938,1.06-.493,.086-.985,.171-1.467,.246-1.146,.182-2.271,.332-3.353,.396-.214,.021-.428,.032-.643,.032-.546,.043-1.071,.043-1.564,.011h-.107c-.482-.032-.932-.107-1.253-.204,.011-.128,.022-.3,.054-.482,.011-.032,.011-.054,.021-.086,.193-1.135,.75-2.613,1.339-4.059,.61-1.446,1.339-2.913,2.11-4.37,.236-.471,.482-.932,.739-1.403v-.021c.525-.985,1.082-1.971,1.607-2.903l.064-.107c.118-.214,.214-.428,.289-.653v-.011c.514-1.617-.097-3.438-1.607-4.37-.696-.428-1.468-.6-2.228-.546-1.168,.064-2.292,.696-2.956,1.767-.878,1.425-1.682,2.838-2.41,4.284v18.005c0,.343,.021,.664,.054,.996v.011c.075,.032,.15,.054,.225,.075,.193,.075,.375,.129,.557,.171,.311,.075,.6,.139,.889,.182,.964,.171,1.832,.161,2.646,.139,1.05-.043,2.024-.171,2.977-.343,1.296-.246,2.528-.546,3.728-.889v-.011c.557-.15,1.114-.321,1.66-.514,2.999-.996,5.837-2.153,8.633-3.535,.428-.214,.846-.428,1.275-.653,.76-.386,1.167-1.264,.953-2.121Zm-21.036,1.264c.021,.011,.064,.043,.118,.086-.075-.032-.118-.053-.139-.075-.021-.021,0-.021,.022-.011Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.482,164.203c-.268,1.307-.761,2.806-1.532,4.531,0,0-2.699,4.884-3.363,6.909-.075,.236-.129,.428-.139,.578l-.278,.418-3.952,5.923-.182,.279c-.011-.118-.021-.236-.043-.354v-.011c-.032-.332-.054-.653-.054-.996v-18.958c2.742-5.163,5.42-6.705,5.623-6.812l.011-.011s5.495,.985,3.91,8.505Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.482,164.203c-.268,1.307-.761,2.806-1.532,4.531,0,0-2.699,4.884-3.363,6.909-.075,.236-.129,.428-.139,.578l-.278,.418-3.952,5.923-.182,.279c-.011-.118-.021-.236-.043-.354v-.011c-.032-.332-.054-.653-.054-.996v-18.958c2.742-5.163,5.42-6.705,5.623-6.812l.011-.011s5.495,.985,3.91,8.505Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.023,176.778c-1.853,1.467-3.502,4.413-4.359,6.137-.396,.793-.621,1.328-.621,1.328l-.675-.064c-.15-.428-.257-.878-.332-1.339-.011-.118-.021-.236-.043-.354v-.011c-.032-.332-.054-.653-.054-.996v-3.32c.9-.793,1.799-1.425,2.539-1.896,.011,0,.011-.011,.022-.011,.161-.107,.321-.204,.471-.3,.717-.428,1.189-.653,1.189-.653l.428,.343,1.253,.985,.182,.15Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.023,176.778c-1.853,1.467-3.502,4.413-4.359,6.137-.396,.793-.621,1.328-.621,1.328l-.675-.064c-.15-.428-.257-.878-.332-1.339-.011-.118-.021-.236-.043-.354v-.011c-.032-.332-.054-.653-.054-.996v-3.32c.9-.793,1.799-1.425,2.539-1.896,.011,0,.011-.011,.022-.011,.161-.107,.321-.204,.471-.3,.717-.428,1.189-.653,1.189-.653l.428,.343,1.253,.985,.182,.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.566,154.31c-.605,2.222-1.313,4.287-2.039,6.414-.758,2.102-1.586,4.188-2.482,6.275-.902,2.094-1.908,4.153-3.161,6.249-.633,1.052-1.336,2.097-2.275,3.193-.22,.268-.518,.56-.778,.832l-.475,.431-.243,.212c-.124,.102-.321,.248-.486,.36-.702,.485-1.764,.892-2.825,.894-1.074,.013-1.9-.302-2.514-.61-1.228-.655-1.791-1.317-2.325-1.915-.51-.603-.897-1.173-1.249-1.732-.696-1.116-1.229-2.187-1.727-3.256-.959-2.144-1.748-4.252-2.443-6.381-1.404-4.251-2.474-8.503-3.338-12.866l4.002-1.172c1.638,3.946,3.346,7.924,5.12,11.748,.906,1.903,1.821,3.79,2.832,5.513,.493,.86,1.011,1.691,1.53,2.374,.257,.339,.517,.642,.732,.846,.194,.199,.428,.306,.176,.136-.13-.073-.425-.207-.953-.216-.517-.01-1.052,.198-1.309,.378-.056,.03-.141,.101-.16,.117l.054-.067,.116-.128c.096-.137,.188-.226,.296-.389,.429-.59,.882-1.39,1.321-2.222,.884-1.682,1.653-3.592,2.426-5.499,.757-1.924,1.454-3.902,2.121-5.899,.699-1.972,1.339-4.032,1.968-5.97l8.085,2.35Z",
    style: {
      fill: "#e7b278"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.166,150.504c4.295,7.489-7.646,22.268-7.646,22.268l-9.07-5.983s2.024-8.369,4.886-14.665c2.999-6.596,8.975-6.599,11.83-1.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.119,162.04c-.74,1.67-1.61,3.27-2.47,4.71-1.1,1.83-2.18,3.39-2.96,4.47-.71,.98-1.17,1.55-1.17,1.55l-4.42-2.91-4.65-3.07s2.03-8.37,4.89-14.67c3-6.59,8.97-6.6,11.83-1.62,1.79,3.12,.75,7.5-1.05,11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.43,156.049l-7.955-.679,1.697-6.771s5.627-.307,7.547,3.927l-1.289,3.523Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.703 152.285 136.176 147.541 140.172 148.599 138.476 155.37 133.703 152.285",
    style: {
      fill: "#ebb376"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.689,171.22c-.71,.98-1.17,1.55-1.17,1.55l-4.42-2.91c.71-6.03,3.68-10,3.68-10,2.13,3.16,2.45,7.57,1.91,11.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.12,162.041c-.736,1.67-1.609,3.271-2.471,4.714-.584-3.515-.087-7.124-.087-7.124,1.112,.501,1.944,1.362,2.558,2.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.499,145.71v.01c-.18,.84-.35,1.67-.5,2.51-.19,1.03-.37,2.06-.53,3.09-.11,.65-.21,1.3-.3,1.95-.12,.83-.23,1.67-.33,2.5-.03,.21-.05,.42-.07,.62-.08,.63-.15,1.25-.22,1.88-.01,.05-.01,.1-.02,.15-.01,.07-.01,.14-.02,.21-.08,.74-.14,1.48-.21,2.22-.02,.31-.05,.62-.07,.93-.11,1.28-.2,2.55-.27,3.81-.01,.11-.01,.22-.02,.33-.05,.89-.09,1.77-.13,2.64-.03,.83-.06,1.64-.08,2.45-.02,.89-.04,1.76-.05,2.62-.02,.91-.02,1.8-.02,2.67,0,.82,.01,1.63,.02,2.42,.01,1.08,.03,2.12,.05,3.13,.01,.51,.02,1.01,.04,1.5s.03,.97,.05,1.44,.03,.93,.05,1.38c.03,.63,.05,1.25,.08,1.84v.01c-1.45,1.37-3.42,2.2-5.57,2.2h-27.34c-.93-6.11-1.38-11.55-1.54-16.34-.03-1.08-.05-2.12-.06-3.13v-.01c-.01-2.46,.06-4.73,.18-6.8,.29-4.92,.91-8.75,1.51-11.5,.57-2.65,1.13-4.3,1.38-4.97,.08-.23,.13-.34,.13-.34h.01l7.82-3s.06-.01,.17-.02h.01c.34-.03,1.06-.11,1.48-.14,.36-.03,.75-.05,1.15-.07,.2-.01,.41-.01,.62-.02,2.36-.07,5.25-.02,7.94,.1,.84,.03,1.66,.07,2.43,.11,.52,.03,1.02,.06,1.49,.09,.22,.02,.44,.03,.65,.05,.65,.05,1.3,.11,1.93,.18,2.3,.24,4.46,.59,5.97,.87,.18,.03,.35,.06,.51,.09,.02,0,.04,.01,.06,.01,.01,0,.02,0,.03,.01,.66,.13,1.14,.22,1.39,.27,.01,.01,.02,.01,.03,.01h.02c.02,.01,.04,.02,.05,.02h.02c.03,.01,.05,.01,.07,.02h.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.489,145.7v.02c-.18,.84-.34,1.67-.49,2.51-.2,1.03-.38,2.07-.54,3.1-.1,.65-.2,1.3-.29,1.94-.12,.84-.23,1.67-.33,2.5-.03,.2-.06,.41-.08,.61-.08,.63-.15,1.26-.21,1.89-.01,.05-.01,.1-.02,.15-.01,.07-.01,.14-.02,.21-.08,.74-.14,1.48-.21,2.22-.03,.31-.05,.61-.08,.92-.1,1.29-.19,2.56-.27,3.82-.01,.11-.02,.23-.01,.33-.05,.89-.09,1.77-.13,2.64-.03,.83-.06,1.64-.08,2.45-.03,.89-.04,1.76-.05,2.62-.02,.91-.02,1.8-.02,2.67,0,.82,0,1.63,.01,2.42,.01,1.08,.03,2.12,.06,3.13,.01,.51,.02,1.01,.04,1.5,.01,.49,.03,.97,.05,1.44,.01,.47,.03,.93,.05,1.38,.03,.63,.05,1.25,.08,1.84v.01c-1.45,1.37-3.42,2.2-5.57,2.2h-27.34c-.92-6.12-1.38-11.57-1.53-16.36-.03-1.07-.05-2.11-.06-3.11-.01-2.48,.05-4.76,.18-6.84,.3-4.91,.91-8.72,1.5-11.47h.01c.57-2.65,1.13-4.3,1.37-4.97,0,0,.01,0,.01-.01,.08-.22,.13-.33,.13-.33l7.82-3s.06-.01,.17-.02h.01c.34-.03,1.06-.11,1.48-.14,.36-.03,.75-.05,1.15-.07,.2-.01,.41-.01,.62-.02,2.36-.07,5.25-.02,7.94,.1,.84,.03,1.66,.07,2.43,.11,.52,.03,1.02,.06,1.49,.09,.22,.02,.44,.03,.65,.05,.65,.05,1.3,.11,1.93,.18,2.3,.24,4.46,.59,5.97,.87,.18,.03,.35,.06,.51,.09,.02,0,.04,.01,.06,.01,.01,0,.02,0,.03,.01,.6,.11,1.05,.2,1.31,.25,.03,0,.05,0,.08,.02h.02c.01,.01,.02,.01,.03,.01,.01,0,.02,.01,.04,.01,.01,0,.02,0,.03,.01,.05,0,.07,.01,.07,.01Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M188.681,143.863s-8.081,4.578-10.246,4.22c-1.517-.25-3.337-3.079-3.337-3.079,1.196-.396,2.067-.919,2.667-1.533,1.821-1.831,1.335-4.471,.464-6.952l7.67-7.812c-.18,1.772-.3,4.135-.166,6.493v.008c.188,3.528,.957,7.062,2.949,8.655Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.731,135.2v.008c-1.249,3.736-3.606,7.907-7.967,8.263,1.821-1.831,1.335-4.471,.464-6.952l7.67-7.812c-.18,1.772-.3,4.135-.166,6.493Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.432,148.084s1.509,1.867,3.281,3.72c2.659-1.236,8.898-4.569,8.705-7.847-.33-.964-2.797-1.648-2.797-1.648,0,0-2.828,3.429-9.189,5.774Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.432,148.084s-2.097,1.519-3.491,3.492c-1.884-1.31-.709-7.358,.02-8.007,1.554-.866,3.342-.757,3.342-.757,0,0-1.461,2.72,.129,5.272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.432,148.084s1.509,1.867,3.281,3.72c2.659-1.236,8.898-4.569,8.705-7.847-.33-.964-2.797-1.648-2.797-1.648,0,0-2.828,3.429-9.189,5.774Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.432,148.084s-2.097,1.519-3.491,3.492c-1.884-1.31-.709-7.358,.02-8.007,1.554-.866,3.342-.757,3.342-.757,0,0-1.461,2.72,.129,5.272Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.798,119.967c-1.07,2.334-1.277,7.378,2.321,6.181,3.598-1.197-.482-10.192-2.321-6.181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.893,125.448c-.41,6.292-.33,9.998-3.527,13.187-4.809,4.797-12.582,1.807-14.063-4.499-1.334-5.676-.438-15.012,5.744-17.434,6.091-2.386,12.257,2.454,11.846,8.746Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.322,127.078c-.002,.513-.276,.925-.611,.92-.336-.005-.606-.424-.604-.937,.002-.513,.276-.925,.611-.92,.336,.004,.606,.424,.604,.937Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.518,126.999c-.002,.513-.276,.925-.611,.92-.335-.005-.606-.424-.604-.937,.002-.513,.275-.925,.611-.92,.336,.005,.606,.424,.604,.937Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.362,127.279s-1.207,2.832-2.51,4.196c.893,.813,2.439,.446,2.439,.446l.071-4.642Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.118,125.231c-.104,.013-.213-.03-.281-.121-.807-1.082-1.917-1.032-1.928-1.032-.166,.01-.31-.117-.321-.283-.011-.166,.115-.308,.281-.318,.059-.004,1.449-.066,2.45,1.276,.1,.134,.073,.323-.06,.421-.043,.032-.092,.05-.142,.056Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.025,124.971c-.057,.007-.116-.002-.172-.03-.149-.075-.211-.256-.138-.404,.735-1.491,2.112-1.65,2.173-1.666,.165-.018,.316,.101,.336,.266,.02,.165-.096,.313-.26,.333-.058,.004-1.117,.141-1.707,1.338-.046,.094-.135,.152-.232,.164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.084,120.242s1.757-1.21,2.524,.137c.767,1.347,.663,4.919,.663,4.919l.36-.625s2.103,7.987,5.378,6.035c3.275-1.952,8.169-9.945,.661-14.182,0,0-.774-1.934-5.764-2.958-4.99-1.025-11.087,1.964-12.176,5.255s.334,5.156,.334,5.156c.291-1.194,.993-1.945,.993-1.945,.098,1.072,1.224,1.542,1.224,1.542-.005-1.306,.44-1.945,.44-1.945,.083,.709,.81,1.604,.81,1.604,.418-3.4,2.745-4.057,3.476-4.018,.901,.049,1.077,1.025,1.077,1.025Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.302,130.703c-.509,1.618-1.722,2.843-2.972,3.459-1.882,.926-3.225-.671-3.039-2.653,.167-1.784,1.347-4.416,3.398-4.515,2.02-.098,3.196,1.859,2.614,3.709Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.456,134.034c.612,.597,1.463,1.829,1.463,1.829,.126-.057,.251-.114,.373-.178,1.683-.816,2.194-1.751,2.25-2.539,.029-.431-.083-.822-.214-1.121-.148-.348-.333-.562-.333-.562-.634,.965-2.144,1.847-2.971,2.284-.344,.186-.569,.287-.569,.287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.025,133.748l.445,.528c1.583-.773,2.595-1.529,2.858-2.25-.148-.348-.333-.562-.333-.562-.634,.965-2.144,1.847-2.971,2.284Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.293,135.686c1.683-.816,2.194-1.751,2.25-2.539-.563,.3-1.208,.725-1.689,1.276-.37,.42-.516,.864-.561,1.263Z",
    style: {
      fill: "#a24e3f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198.509,158.63c-.24,2.37-.42,4.69-.56,6.96-.01,.11-.02,.23-.01,.33-.05,.89-.09,1.77-.13,2.64-2.72-5.73-3.84-12.16-3.84-12.16,1.58,.17,3.09,.87,4.5,1.9,.01,.11,.03,.22,.04,.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.529,150.54v8.4c-.58-.85-1.17-1.71-1.76-2.55q0-.01-.01-.01c-.7-1.01-1.4-2.01-2.09-3l2.79-2.05,.01-.01,1.06-.78Z",
    style: {
      fill: "#e7b278"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,145.73v18.56c-.72-.76-1.5-1.61-2.3-2.51,0,0-.01,0-.01-.01-1.44-1.61-2.93-3.4-4.21-5.17v-.01c-.05-.06-.09-.1-.13-.16-4.24-5.88-1.27-11.06,4.47-11.07,.18,0,.35,.01,.53,.02,.01,0,.02,0,.03,.01,.43,.03,.87,.12,1.29,.25h.02c.03,0,.05,0,.08,.02h.02l.01,.01h.02c.01,0,.02,.01,.04,.01l.01,.01h.02c.01,.01,.02,.01,.04,.01,.01,0,.02,.01,.03,.02h.01c.01,0,.02,0,.03,.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,145.73v18.56c-.72-.76-1.5-1.61-2.3-2.51,0,0-.01,0-.01-.01-1.44-1.61-2.93-3.4-4.21-5.17v-.01c-.05-.06-.09-.1-.13-.16-4.24-5.88-1.27-11.06,4.47-11.07,.18,0,.35,.01,.53,.02,.01,0,.02,0,.03,.01,.43,.03,.87,.12,1.29,.25h.02c.03,0,.05,0,.08,.02h.02l.01,.01h.02c.01,0,.02,.01,.04,.01l.01,.01h.02c.01,.01,.02,.01,.04,.01,.01,0,.02,.01,.03,.02h.01c.01,0,.02,0,.03,.01Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_bubbles--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.681,80.057h-19.116c-5.772,0-10.451,4.679-10.451,10.451v12.612c0,5.771,4.679,10.451,10.45,10.451h1.737l-1.007,7.65,8.037-7.65h10.35c5.771,0,10.45-4.679,10.45-10.451v-12.612c0-5.772-4.679-10.451-10.45-10.451Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.681,80.057h-19.116c-5.772,0-10.451,4.679-10.451,10.451v12.612c0,5.771,4.679,10.451,10.45,10.451h1.737l-1.007,7.65,8.037-7.65h10.35c5.771,0,10.45-4.679,10.45-10.451v-12.612c0-5.772-4.679-10.451-10.45-10.451Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.625,67.759h19.115c5.772,0,10.451,4.678,10.451,10.45v12.612c0,5.772-4.679,10.45-10.45,10.45h-1.736l1.007,7.651-8.037-7.651h-10.35c-5.771,0-10.45-4.679-10.45-10.45v-12.612c0-5.772,4.679-10.45,10.45-10.45Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.625,67.759h19.115c5.772,0,10.451,4.678,10.451,10.45v12.612c0,5.772-4.679,10.45-10.45,10.45h-1.736l1.007,7.651-8.037-7.651h-10.35c-5.771,0-10.45-4.679-10.45-10.45v-12.612c0-5.772,4.679-10.45,10.45-10.45Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.661,84.44c0,1.551-1.257,2.808-2.808,2.808s-2.808-1.257-2.808-2.808,1.257-2.808,2.808-2.808,2.808,1.257,2.808,2.808Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.991,84.44c0,1.551-1.257,2.808-2.808,2.808s-2.808-1.257-2.808-2.808,1.257-2.808,2.808-2.808,2.808,1.257,2.808,2.808Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.321,84.44c0,1.551-1.257,2.808-2.808,2.808s-2.808-1.257-2.808-2.808,1.257-2.808,2.808-2.808,2.808,1.257,2.808,2.808Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.031,97.438c0,1.551-1.257,2.808-2.808,2.808s-2.808-1.257-2.808-2.808,1.257-2.808,2.808-2.808,2.808,1.257,2.808,2.808Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.361,97.438c0,1.551-1.257,2.808-2.808,2.808s-2.808-1.257-2.808-2.808,1.257-2.808,2.808-2.808,2.808,1.257,2.808,2.808Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.691,97.438c0,1.551-1.257,2.808-2.808,2.808s-2.808-1.257-2.808-2.808,1.257-2.808,2.808-2.808,2.808,1.257,2.808,2.808Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_1--inject-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M267.532,191.638c3.215,3.705,10.536,12.334,13.777,15.751,2.441,2.61,4.216,4.387,7.056,5.862,5.653,3.152,16.111,7.878,22.057,10.764,1.292,.605,1.847,2.148,1.234,3.436-.524,1.102-1.732,1.66-2.875,1.409-4.741-1.038-9.381-2.276-14.006-3.74-4.439-1.448-8.921-2.957-13.109-5.139-2.885-1.585-5.291-3.752-7.287-5.617-5.367-5.057-10.186-10.444-14.815-16.153-4.081-5.375,3.458-11.61,7.969-6.573h0Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.472,188.374c8.854,2.128,22.513,21.565,22.513,21.565l-6.913,7.01-14.534-10.745-1.066-17.83Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.981,209.94l-6.91,7.01-7.38-5.46-7.15-5.29-.51-8.56-.56-9.27c8.85,2.13,22.51,21.57,22.51,21.57Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.691,211.49l-7.15-5.29-.51-8.56c2.23,2,6.19,6.45,7.66,13.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.914,146.708c.25-2.628,9.746-6.504,14.195-5.227,4.45,1.277,2.05,3.313,5.165,3.252,3.115-.061,6.838,.81,7.657,3.566,.819,2.756-3.266,6.297-.585,7.59,2.681,1.294,6,4.996,2.809,8.06s-12.851,8.043-22.702,7.532c-9.851-.511-11.481-13.325-10.108-17.549,0,0-3.062-1.112-3.7,2.41s3.575,6.501,1.277,9.352c-2.298,2.851-4.091,4.128-1.343,6.809,2.747,2.68-1.082,6.464-3.38,5.912,0,0,1.217-.168,.864-2.083-.353-1.915-4.311-.602-5.97-5.535-1.66-4.933,2.043-5.409,.894-7.579-1.149-2.17-4.213-1.468-4.213-5.817,0-3.171,4.677-5.708,5.953-7.878s-1.061-3.235,1.196-7.148c1.502-2.605,6.143-2.299,8.424-1.179,3.959,1.945,3.57,5.513,3.57,5.513Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.133,403.269l1.149,.974,1.523-1.146,2.342,4.943,9.626,8.179s2.838-.238-.704-5.36c-.161-.233-.309-.497-.438-.8-1.471-3.223-1.66-10.05-1.66-10.05l-5.282-4.488s-.409,.108-1.08,.394c-1.564,.672-4.633,2.264-5.476,7.354Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.133,403.269l1.149,.974,1.523-1.146,2.342,4.943,9.626,8.179s2.838-.238-.704-5.36c-.161-.233-.309-.497-.438-.8-1.471-3.223-1.66-10.05-1.66-10.05l-5.282-4.488s-.409,.108-1.08,.394c-1.564,.672-4.633,2.264-5.476,7.354Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.609,395.914l-.014,.016c1.358-.185,1.631,5.926,2.968,9.063,1.197,2.798,3.142,5.236,5.068,5.065-1.471-3.223-1.063-11.494-1.063-11.494l-4.247-3.609s-2.041,.673-2.712,.959Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.609,395.914l-.014,.016c1.358-.185,1.631,5.926,2.968,9.063,1.197,2.798,3.142,5.236,5.068,5.065-1.471-3.223-1.063-11.494-1.063-11.494l-4.247-3.609s-2.041,.673-2.712,.959Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M233.854,418.075l1.506-.002,.418-1.86,4.985,2.251h12.632s2.009-2.019-4.007-3.628c-.274-.074-.558-.179-.852-.326-3.208-1.504-7.772-6.584-7.772-6.584h-6.931s-.242,.347-.568,.999c-.757,1.525-2.065,4.725,.589,9.15Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.265,408.925v.021c.915-1.02,5.08,3.461,8.13,4.985,2.724,1.357,5.785,1.956,7.141,.579-3.208-1.504-8.252-8.071-8.252-8.071h-5.574s-1.119,1.835-1.445,2.487Z",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.587,335.605c-3.18,6.335-6.384,13.16-9.449,19.981-4.035,9.003-7.83,18.018-11.055,26.085-2.308,5.756-5.311,13.023-6.892,17.416-4.939-.523-7.25-2.379-9.209-3.907,1.179-7.912,4.34-28.442,10.308-46.511,3.139-9.505,7.052-18.884,11.871-26.521-22.543-58.132-18.177-80.332-18.177-80.332l23.914-1.832s4.316,21.784,7.93,44.15v.01c1.884,11.726,3.574,23.608,4.35,32.598l.003,.09c.557,6.476-.677,12.968-3.594,18.774Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.849,304.844c-3.349-9.896-5.81-18.48-7.588-25.852,1.346-5.854,3.362-10.892,6.223-13.974,0,0,4.767,16.036,1.365,39.827Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.084,381.672c-2.308,5.756-5.311,13.023-6.892,17.416-4.939-.523-7.25-2.379-9.209-3.907,1.179-7.912,4.34-28.442,10.308-46.511,2.059,9.679,4.41,21.921,5.794,33.002Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.257,237.649s-6.974,53.967-10.971,79.938c-4.198,27.276-4.731,71.042-3.681,88.878-1.528,.888-7.097,1.961-10.107,1.02,0,0-14.223-55.164-4.776-87.204-8.603-63.11,3.847-78.565,3.847-78.565l25.687-4.067Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.933,203.67c-10.259-9.631-23.141-16.132-23.141-16.132,.76-.088,1.543-.165,2.325-.232,5.895-.485,10.722-.837,15.978-.54,1.322,.077,2.678,.187,4.011,.298v.011c3.306,7.57,.826,16.595,.826,16.595Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M231.792,237.649l34.872-2.351s1.048,10.472,.805,10.322c-.243-.15-37.327,1.308-37.327,1.308l1.65-9.278Z",
    style: {
      fill: "#263238"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.109 238.225 266.615 236.32 266.615 239.589 231.792 241.442 232.109 238.225"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.53,240.987c-.521,0-.953-.396-.994-.923l-.149-1.917c-.043-.549,.369-1.031,.918-1.076l3.78-.294c.274-.021,.553,.074,.757,.263,.204,.188,.321,.456,.321,.734v2.02c0,.531-.415,.97-.946,.999l-3.63,.192c-.019,0-.038,.002-.057,.002Zm-.321-.976c.014,.178,.166,.291,.341,.3l3.63-.192c.172-.01,.308-.152,.308-.325v-2.02c0-.092-.037-.176-.105-.238s-.158-.098-.246-.085l-3.78,.294c-.179,.014-.313,.171-.299,.35l.149,1.917Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.792,237.649c-.727-8.187-3.658-23.191-8.705-38.949-1.642-5.124-.518-8.624-.518-8.624,0,0,8.529-2.462,9.224-2.539,.76-.088,1.543-.165,2.325-.232,5.895-.485,10.722-.837,15.978-.54,1.322,.077,2.678,.187,4.011,.298,.43,.044,7.946,1.266,8.365,1.311,0,0,3.999,6.469,4.407,12.662,.22,3.46,.738,6.072,.551,14.347-.033,5.62-.814,20.936-.814,20.936-1.071,5.921-13.316,1.329-13.316,1.329-17.418,8.625-21.507,0-21.507,0Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.431,215.38c-.03,5.62-.82,20.94-.82,20.94-1.07,5.92-13.31,1.33-13.31,1.33-17.42,8.62-21.51,0-21.51,0-.49-5.54-1.99-14.19-4.48-24.09-.69-2.79-1.47-5.67-2.32-8.62-.6-2.06-1.23-4.14-1.9-6.24-1.65-5.12-.52-8.62-.52-8.62,0,0,8.53-2.47,9.22-2.54,.76-.09,1.54-.17,2.33-.23,5.89-.49,10.72-.84,15.98-.54,1.32,.07,2.67,.18,4.01,.29,.43,.05,7.94,1.27,8.36,1.31,0,0,4,6.47,4.41,12.67,.22,3.46,.74,6.07,.55,14.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.314,202.269c0,.3-.243,.544-.544,.544s-.543-.243-.543-.544,.243-.544,.543-.544,.544,.243,.544,.544Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.3,213.769c0,.3-.243,.544-.544,.544s-.544-.243-.544-.544,.243-.544,.544-.544,.544,.243,.544,.544Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.3,
    cy: 224.74,
    r: 0.544,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.843,
    cy: 235.298,
    r: 0.544,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.311,213.56c-.69-2.79-1.47-5.67-2.32-8.62,.84-3.98,1.67-7.27,1.67-7.27,0,0,2.45,9.09,.65,15.89Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.262,183.488c14.213-.04,18.808,10.758,18.808,10.758l-6.683-1.362s-1.999,6.05-4.169,7.706c0,0-8.552-2.004-12.808-6.6l-6.168,1.702s-3.26-12.165,11.019-12.205Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.262,183.488c14.213-.04,18.808,10.758,18.808,10.758l-6.683-1.362s-1.999,6.05-4.169,7.706c0,0-8.552-2.004-12.808-6.6l-6.168,1.702s-3.26-12.165,11.019-12.205Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.158,189.02c1.686,6.143-1.939,11.57-1.939,11.57-10.765-3.394-15.218-13.311-15.218-13.311,3.218-3.548,1.19-12.904-.375-18.006l4.309,3.229,6.413,4.793c-.154,1.069-.011,2.534,.309,3.945,.485,2.039,1.355,3.956,2.314,4.364l4.188,3.416Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.656,181.241c-2.557-.573-5.907-3.218-6.447-5.829-.22-1.102-.319-2.182-.275-2.909l6.413,4.793c-.154,1.069-.011,2.534,.309,3.945Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.885,159.109c1.843,8.248,2.448,11.769,7.321,15.589,7.33,5.746,17.011,2.243,17.658-6.252,.582-7.646-2.53-19.85-11.178-22.299-8.52-2.413-15.645,4.714-13.801,12.962Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.534,160.13c.125,.699,.59,1.226,1.038,1.178,.449-.048,.711-.654,.586-1.353-.125-.699-.59-1.226-1.038-1.178s-.711,.654-.586,1.353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.24,158.917c.125,.699,.59,1.226,1.038,1.178,.449-.049,.711-.654,.586-1.353-.125-.699-.59-1.226-1.038-1.178-.449,.048-.711,.654-.586,1.353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.635,157.624l1.562-.662s-.612,1.403-1.562,.662Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.848,160.742s1.702,2.883,3.243,4.196c-.752,.959-2.363,.732-2.363,.732l-.88-4.928Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.462,155.889c.108-.002,.212-.047,.284-.134,1.132-1.357,2.634-1.126,2.651-1.123,.223,.035,.424-.115,.445-.34,.02-.225-.146-.437-.372-.475-.079-.013-1.964-.304-3.368,1.38-.14,.168-.109,.429,.068,.583,.086,.074,.19,.11,.291,.108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,153.929c.102,.011,.205-.015,.287-.082,.169-.139,.184-.398,.034-.579-1.505-1.814-3.379-1.694-3.458-1.688-.224,.017-.378,.215-.344,.442,.033,.227,.241,.397,.465,.381,.073-.006,1.529-.077,2.725,1.365,.077,.093,.184,.148,.291,.159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.929,158.837l1.562-.662s-.612,1.403-1.562,.662Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.118,163.886s4.054-5.908,.962-14.651c0,0,9.171-4.445,16.117,2.342,0,0-6.46-11.335-19.955-5.907-13.495,5.429-3.321,18.385-1.651,19.463,1.67,1.078,4.526-1.247,4.526-1.247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.238,166.238c1.207,1.584,2.948,2.452,4.465,2.631,2.281,.269,2.936-2.035,1.896-4.151-.936-1.905-3.252-4.34-5.346-3.627-2.063,.702-2.396,3.336-1.015,5.147Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.206,167.587c-.544,1.134-1.099,3.266-1.099,3.266-.202-.015-.405-.031-.605-.057-2.738-.278-3.916-1.312-4.392-2.374-.258-.582-.299-1.178-.269-1.658,.029-.556,.176-.945,.176-.945,1.363,1.015,3.896,1.471,5.258,1.658,.57,.084,.932,.11,.932,.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.274,167.478l-.349,.954c-2.578-.269-4.357-.804-5.085-1.667,.029-.556,.176-.945,.176-.945,1.363,1.015,3.896,1.471,5.258,1.658Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.501,170.797c-2.738-.278-3.916-1.312-4.392-2.374,.929,.131,2.035,.392,2.979,.912,.723,.394,1.148,.933,1.413,1.462Z",
    style: {
      fill: "#de5753"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.569,190.077c-5.398,1.392-17.29,22.11-19.961,32.177-2.671,10.066,3.038,14.312,8.737,10.21,5.699-4.102,.223-9.259,14.805-23.39,0,0,.851-3.367,.724-9.337-.128-5.97-4.304-9.66-4.304-9.66Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.569,190.077c-5.398,1.392-17.29,22.11-19.961,32.177-2.671,10.066,3.038,14.312,8.737,10.21,5.699-4.102,.223-9.259,14.805-23.39,0,0,.851-3.367,.724-9.337-.128-5.97-4.304-9.66-4.304-9.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.621,221.383s-5.046,.242-7.003,3.27c-1.958,3.028,0,9.496,2.979,10.645,2.979,1.149,4.986-.608,6.809-3.276s2.017-10.756-2.784-10.638Z",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.621,221.383s-5.046,.242-7.003,3.27c-1.958,3.028,0,9.496,2.979,10.645,2.979,1.149,4.986-.608,6.809-3.276s2.017-10.756-2.784-10.638Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.981,
    y: 208.185,
    width: 106.436,
    height: 29.678,
    transform: "translate(-14.167 17.68) rotate(-3.788)",
    style: {
      fill: "#071530"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.981,
    y: 208.185,
    width: 106.436,
    height: 29.678,
    transform: "translate(-14.167 17.68) rotate(-3.788)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.857,228.251l.562-1.504c.74,.468,1.817,.758,2.822,.691,1.149-.076,1.59-.49,1.556-1.005-.104-1.568-4.903-.168-5.109-3.28-.094-1.423,.976-2.684,3.358-2.842,1.053-.07,2.147,.11,2.957,.549l-.501,1.511c-.807-.392-1.623-.554-2.365-.505-1.149,.076-1.563,.536-1.528,1.063,.102,1.543,4.902,.156,5.106,3.231,.093,1.4-.989,2.674-3.382,2.832-1.328,.088-2.695-.218-3.475-.743Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.405,224.374c-.165-2.49,1.652-4.46,4.296-4.635,2.633-.174,4.705,1.527,4.871,4.028,.166,2.5-1.664,4.461-4.297,4.635-2.645,.175-4.705-1.539-4.87-4.028Zm7.204-.477c-.105-1.592-1.302-2.606-2.799-2.507-1.496,.099-2.549,1.262-2.443,2.854,.105,1.591,1.302,2.606,2.798,2.507,1.496-.099,2.549-1.263,2.444-2.854Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.802,220.909l.147,2.214,3.877-.257,.103,1.555-3.877,.257,.202,3.052-1.939,.128-.555-8.377,6.33-.419,.103,1.556-4.392,.291Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.311,220.435l-2.681,.177-.104-1.579,7.3-.483,.105,1.579-2.681,.178,.45,6.798-1.939,.128-.45-6.798Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.101,225.851l.561-1.504c.74,.468,1.817,.758,2.822,.691,1.149-.076,1.59-.49,1.556-1.005-.104-1.568-4.903-.168-5.109-3.28-.094-1.423,.976-2.684,3.358-2.842,1.053-.07,2.147,.11,2.957,.549l-.501,1.512c-.807-.392-1.623-.554-2.365-.505-1.149,.076-1.563,.536-1.528,1.063,.102,1.543,4.902,.156,5.106,3.231,.093,1.4-.989,2.674-3.382,2.832-1.328,.088-2.695-.218-3.475-.743Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.287,222.634l-1.047,1.247,.14,2.118-1.926,.127-.555-8.377,1.926-.128,.259,3.913,3.451-4.159,2.154-.143-3.223,3.963,3.981,4.4-2.262,.15-2.899-3.113Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.759,217.164l1.939-.128,.555,8.377-1.939,.128-.555-8.377Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.686,216.904l1.939-.128,.45,6.797,4.2-.278,.105,1.58-6.139,.407-.555-8.377Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.919,216.425l1.939-.128,.45,6.797,4.2-.278,.105,1.579-6.139,.407-.555-8.377Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.944,223.544l.561-1.504c.74,.468,1.817,.758,2.822,.691,1.149-.076,1.59-.49,1.556-1.004-.104-1.568-4.903-.169-5.109-3.28-.094-1.423,.976-2.684,3.358-2.842,1.053-.07,2.147,.11,2.957,.549l-.501,1.511c-.807-.392-1.623-.554-2.365-.505-1.149,.076-1.563,.536-1.528,1.063,.102,1.544,4.902,.156,5.106,3.231,.093,1.4-.989,2.674-3.382,2.832-1.328,.088-2.695-.218-3.475-.743Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.564,224.654l3.522-5.484,2.617,10.821s-2.864,4.027-5.884,1.802l-.603-1.239c-.921-1.893-.789-4.128,.348-5.9Z",
    style: {
      fill: "#d9877c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.603 221.628 214.827 228.695 209.703 229.991 207.086 219.17 215.603 221.628",
    style: {
      fill: "#d9877c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,216.296s6.724-3.784,8.17-3.071c2.903,1.432,3.307,11.561-1.091,12.901l-.136-2.057-4.773-.728-2.17-7.046Z",
    style: {
      fill: "#d9877c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.a55d966f4a6c002832d25894455456ee.svg";
export { ForwardRef as ReactComponent };